;(() => {
  const POPUP_SELECTOR = ".bundle-options-popup"
  const CLOSE_SELECTOR = "[data-bundle-popup-close]"
  const TRIGGER_SELECTOR = "[data-bundle-options-trigger]"
  const ADD_BTN_SELECTOR = "[data-bundle-add-to-cart]"
  const SIZE_BTN_SELECTOR =
    '[data-option-type="size"] button[data-option-value]'
  const COLOR_BTN_SELECTOR =
    '[data-option-type="color"] button[data-option-value]'
  const EXTRA_BTN_SELECTOR =
    '[data-option-type="extra"] button[data-option-value]'
  const CART_SECTION_ID = "cart-drawer"

  let lastTrigger = null
  let variantMap = []
  let selectedSize = ""
  let selectedColor = ""
  let selectedExtra = ""
  let isDualSizeMode = false
  let isMultiDim = false

  let sizeComponent = null
  let colorComponent = null
  let extraComponent = null
  let componentDataReady = false
  let componentDataPromise = null
  let pdpColorData = null
  let enrichmentDone = false
  let enrichmentPromise = null
  let isTitleFallback = false
  let sizeComponentHint = null
  let exclusiveByColor = Object.create(null)
  let exclusiveByExtra = Object.create(null)
  var exclusiveHandleCache = Object.create(null)
  let defaultColorLabelText = ""
  let defaultExtraLabelText = ""
  let exclusiveCartQueue = Promise.resolve()
  let sizeChartMarkupCache = Object.create(null)
  let activePopupId = ""
  let activeStateVersion = 0
  let selfEntryDiscoveryQueue = Promise.resolve()
  let selfEntryResultCache = Object.create(null)
  let selfEntryRequestCache = Object.create(null)
  let cartRateLimitUntil = 0

  // WEBD-1281: Progressive modal rendering - don't wait for enrichment
  let enrichmentTimeoutId = null
  const ENRICHMENT_SHOW_TIMEOUT = 1500 // ms - show modal if enrichment takes longer

  // WEBD-1281: Persistent cache so repeat visits skip the slow cart-add discovery.
  const BUNDLE_CACHE_PREFIX = "tb_bundle_cache_v1::"
  const BUNDLE_CACHE_TTL_MS = 24 * 60 * 60 * 1000 // 24h

  function readBundleCache(key) {
    if (!key) return null
    try {
      const raw = window.localStorage.getItem(BUNDLE_CACHE_PREFIX + key)
      if (!raw) return null
      const parsed = JSON.parse(raw)
      if (!parsed || typeof parsed !== "object") return null
      if (!parsed.t || Date.now() - parsed.t > BUNDLE_CACHE_TTL_MS) {
        return null
      }
      return parsed.v
    } catch (e) {
      return null
    }
  }

  function writeBundleCache(key, value) {
    if (!key) return
    try {
      window.localStorage.setItem(
        BUNDLE_CACHE_PREFIX + key,
        JSON.stringify({ t: Date.now(), v: value }),
      )
    } catch (e) {
      /* quota/private mode - ignore */
    }
  }

  const EXCLUSIVE_LABELS = {
    de: "LIMITIERTE EDITION",
    fr: "ÉDITION LIMITÉE",
    it: "EDIZIONE LIMITATA",
    es: "EDICIÓN LIMITADA",
    en: "LIMITED EDITION",
  }

  const LABEL_SWATCH_HEX = {
    peach: "#ffaf9a",
    gray: "#53565a",
    "gray-discontinued": "#53565a",
    indigo: "#524a7b",
    oat: "#c5b9ac",
    charcoal: "#25282a",
    red: "#bc1c1c",
    blue: "#307cdd",
    navy: "#35516e",
    sand: "#dac8b7",
    "adventure-green": "#024638",
    "desert-rose": "#ae7f68",
    desertrose: "#ae7f68",
    white: "#ffffff",
    black: "#000000",
    "polar-blue": "#94a9cb",
    "alpine-green": "#92aca0",
    "twilight-pink": "#d5c2d8",
  }

  function init() {
    const triggers = document.querySelectorAll(TRIGGER_SELECTOR)
    const popups = document.querySelectorAll(POPUP_SELECTOR)
    if (!triggers.length || !popups.length) return

    popups.forEach((popup) => {
      popup.querySelectorAll(CLOSE_SELECTOR).forEach((el) => {
        el.addEventListener("click", () => close(popup))
      })

      popup.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          const sizeChartLayer = popup.querySelector(
            "[data-bundle-size-chart-layer].is-visible",
          )
          if (sizeChartLayer) {
            const backBtn = popup.querySelector(
              "[data-bundle-back-from-size-chart]",
            )
            if (backBtn) backBtn.click()
          } else {
            close(popup)
          }
        }
      })

      initOptionSelectors(popup)
      initAddToCart(popup)
      initSizeChart(popup)
    })

    triggers.forEach((trigger) => {
      const popup = getPopupForTrigger(trigger)
      if (!popup) return
      trigger.addEventListener("click", () => {
        lastTrigger = trigger
        preparePopupState(popup)
        openPopup(popup)
      })
    })

    scheduleInitialPopupPrefetch(popups)
  }

  function scheduleInitialPopupPrefetch(popups) {
    const popup = popups && popups.length ? popups[0] : null
    if (!popup) return

    if (activePopupId || popup.getAttribute("aria-hidden") === "false") return
    preparePopupState(popup)
  }

  function getPopupForTrigger(trigger) {
    if (!trigger) return null
    const popupId = trigger.dataset.bundlePopupId || ""
    if (popupId) {
      return document.getElementById(popupId)
    }
    return document.querySelector(POPUP_SELECTOR)
  }

  function getActivePopup() {
    if (activePopupId) {
      const popup = document.getElementById(activePopupId)
      if (popup) return popup
    }
    return (
      document.querySelector(POPUP_SELECTOR + '[aria-hidden="false"]') ||
      document.querySelector(POPUP_SELECTOR)
    )
  }

  function resetPopupState() {
    variantMap = []
    selectedSize = ""
    selectedColor = ""
    isDualSizeMode = false
    sizeComponent = null
    colorComponent = null
    componentDataReady = false
    componentDataPromise = null
    pdpColorData = null
    enrichmentDone = false
    enrichmentPromise = null
    isTitleFallback = false
    sizeComponentHint = null
    exclusiveByColor = Object.create(null)
    exclusiveByExtra = Object.create(null)
    defaultColorLabelText = ""
    defaultExtraLabelText = ""
  }

  function isStaleState(stateVersion) {
    return stateVersion !== activeStateVersion
  }

  function preparePopupState(popup) {
    if (!popup) return
    if (activePopupId === popup.id && variantMap.length) return

    activeStateVersion += 1
    resetPopupState()
    activePopupId = popup.id
    loadVariantMap(popup)

    const activeSize = popup.querySelector(SIZE_BTN_SELECTOR + ".is-active")
    if (activeSize) selectedSize = activeSize.dataset.optionValue || ""

    const activeColor = popup.querySelector(COLOR_BTN_SELECTOR + ".is-active")
    if (activeColor) selectedColor = activeColor.dataset.optionValue || ""

    // WEBD-1281: Strip server-rendered wrapper bundle text/image now (before
    // enrichment completes) so users never see "Anti-Aging Bundle" flash in
    // place of the real component name. The real name/image is applied as
    // soon as enrichment resolves.
    clearWrapperDisplayInPopup(popup)

    const usedPreloaded = loadPreloadedComponents()
    applyComponentFallbacks()

    updateAvailability(popup)
    updateSelection(popup)

    if (!usedPreloaded) {
      discoverComponents()
    }
  }

  function clearWrapperDisplayInPopup(popup) {
    if (!popup) return
    var wrapperTypes = Object.create(null)
    var nameEls = popup.querySelectorAll("[data-component-name]")
    nameEls.forEach(function (el) {
      var type = el.getAttribute("data-component-name") || ""
      var text = (el.textContent || "").trim()
      if (text && componentNameLooksLikeWrapper(text)) {
        if (!el.dataset.tbOrigText) el.dataset.tbOrigText = text
        el.textContent = ""
        el.classList.add("is-awaiting-component")
        if (type) wrapperTypes[type] = true
      }
    })

    var hasWrapper = Object.keys(wrapperTypes).length > 0

    // Hide images that came with wrapper-name component so the shimmer
    // overlay isn't fighting a wrong picture underneath. Also add shimmer
    // class when Liquid rendered a placeholder div instead of an img.
    Object.keys(wrapperTypes).forEach(function (type) {
      var container = popup.querySelector('[data-component-img="' + type + '"]')
      if (!container) return
      var img = container.querySelector("img")
      if (img) {
        var src = img.getAttribute("src") || ""
        if (src) {
          if (!img.dataset.tbOrigSrc) img.dataset.tbOrigSrc = src
          img.style.visibility = "hidden"
        }
      }
      container.classList.add("is-awaiting-component")
    })

    var genEls = popup.querySelectorAll("[data-component-gen]")
    genEls.forEach(function (el) {
      el.classList.remove("is-visible")
    })

    // WEBD-1281: popup-level flag drives shimmer for option buttons too.
    // Stays on until real enrichment lands (see clearLoadingState).
    if (hasWrapper) {
      popup.classList.add("is-loading-component-data")
    }
  }

  function clearLoadingState(popup) {
    if (!popup) return
    if (!enrichmentDone) return
    popup.classList.remove("is-loading-component-data")
  }

  function loadVariantMap(popup) {
    const sectionId = popup.id.replace("BundleOptionsPopup-", "")
    const variantEl = document.getElementById("BundleVariantMap-" + sectionId)
    if (variantEl) {
      try {
        variantMap = JSON.parse(variantEl.textContent)
      } catch (e) {
        /* ignore */
      }
    }
    isTitleFallback = popup.dataset.titleFallback === "true"
    isDualSizeMode = popup.dataset.dualSizeMode === "true"
    isMultiDim = popup.dataset.multiDim === "true"
    selectedExtra = ""
    extraComponent = null
    sizeComponentHint = null
    if (popup.dataset.sizeComponentHintHandle) {
      sizeComponentHint = {
        handle: popup.dataset.sizeComponentHintHandle,
        name: popup.dataset.sizeComponentHintTitle || "",
        image: popup.dataset.sizeComponentHintImage || "",
        generation: popup.dataset.sizeComponentHintGeneration || "",
      }
    }
    if (!isDualSizeMode) normalizeColorOptions(popup)
  }

  function normalizeColorOptions(popup) {
    if (isMultiDim) return
    var colors = []
    var seen = Object.create(null)
    for (var i = 0; i < variantMap.length; i++) {
      var c = variantMap[i].color
      if (c && !seen[c]) {
        seen[c] = true
        colors.push(c)
      }
    }
    if (colors.length < 2) return

    var wordArrays = colors.map(function (c) {
      return c.split(/\s+/)
    })
    var minLen = wordArrays.reduce(function (m, a) {
      return Math.min(m, a.length)
    }, Infinity)

    var prefixCount = 0
    for (var i = 0; i < minLen - 1; i++) {
      var ref = wordArrays[0][i].toLowerCase()
      var ok = true
      for (var j = 1; j < wordArrays.length; j++) {
        if (wordArrays[j][i].toLowerCase() !== ref) {
          ok = false
          break
        }
      }
      if (ok) prefixCount = i + 1
      else break
    }

    var cleaned = colors.map(function (c) {
      var words = c.split(/\s+/)
      var remaining = words.slice(prefixCount).join(" ").trim()
      var parenOnly = remaining.match(/^\(([^)]+)\)$/)
      if (parenOnly) {
        remaining = parenOnly[1]
      } else {
        remaining = remaining.replace(/\s*\([^)]*\)\s*$/g, "").trim()
      }
      return remaining || c
    })

    if (cleaned.length > 1 && cleaned[0].length > 2) {
      var refLow = cleaned[0].toLowerCase()
      var charSuffix = 0
      for (var k = 1; k <= Math.min(refLow.length - 2, 12); k++) {
        var tail = refLow.slice(-k)
        var allMatch = true
        for (var m = 1; m < cleaned.length; m++) {
          var cl = cleaned[m].toLowerCase()
          if (cl.length <= k + 1 || cl.slice(-k) !== tail) {
            allMatch = false
            break
          }
        }
        if (allMatch) charSuffix = k
        else break
      }
      if (charSuffix >= 3) {
        cleaned = cleaned.map(function (cc) {
          return cc.slice(0, -charSuffix).trim() || cc
        })
      }
    }

    var UPCASE_SHORT = /^(xs|s|m|l|xl|xxl)$/i
    cleaned = cleaned.map(function (cc) {
      if (UPCASE_SHORT.test(cc)) return cc.toUpperCase()
      return cc.charAt(0).toUpperCase() + cc.slice(1)
    })

    var cleanMap = Object.create(null)
    var hasChanges = false
    for (var i = 0; i < colors.length; i++) {
      if (cleaned[i] && cleaned[i] !== colors[i]) {
        cleanMap[colors[i]] = cleaned[i]
        hasChanges = true
      }
    }
    if (!hasChanges) return

    variantMap.forEach(function (v) {
      if (v.color && cleanMap[v.color]) v.color = cleanMap[v.color]
    })
    if (selectedColor && cleanMap[selectedColor])
      selectedColor = cleanMap[selectedColor]

    if (!popup) return
    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach(function (btn) {
      var old = btn.dataset.optionValue
      if (old && cleanMap[old]) {
        btn.dataset.optionValue = cleanMap[old]
        btn.title = cleanMap[old]
      }
    })
    var headerVal = popup.querySelector(
      '[data-option-type="color"] [data-option-value]',
    )
    if (
      headerVal &&
      headerVal.textContent &&
      cleanMap[headerVal.textContent.trim()]
    ) {
      headerVal.textContent = cleanMap[headerVal.textContent.trim()]
    }
  }

  function buildHintedSingleProductComponent(hint, options) {
    if (!hint || !hint.handle || !options.length) return null
    return {
      name: hint.name || "",
      handle: hint.handle,
      baseHandle: hint.handle,
      defaultImage: hint.image || null,
      images: {},
      titles: {},
      swatches: {},
      swatchImages: {},
      allHandles: options.map((option) => ({
        option,
        handle: hint.handle,
      })),
      generation: hint.generation || "",
      generations: {},
      singleProduct: true,
    }
  }

  function getUniqueHandlesForComponent(component) {
    if (!component) return []
    const handles = []

    if (component.handle) handles.push(component.handle)
    if (component.allHandles && component.allHandles.length) {
      component.allHandles.forEach((entry) => {
        if (entry && entry.handle) handles.push(entry.handle)
      })
    }

    return [...new Set(handles.filter(Boolean))]
  }

  function shouldPreferSizeHintComponent(sizes, component) {
    if (isDualSizeMode) return false
    if (!sizeComponentHint || !sizeComponentHint.handle || !sizes.length) {
      return false
    }
    if (!component) return true

    const uniqueHandles = getUniqueHandlesForComponent(component)
    if (!uniqueHandles.length) return true
    if (uniqueHandles.includes(sizeComponentHint.handle)) return false

    if (component.singleProduct) return true
    if (sizes.length > 1 && uniqueHandles.length <= 1) return true

    return false
  }

  function variantHasSerializedComponentData(variant, type) {
    if (!variant) return false

    if (type === "size") {
      return !!(
        variant.sizeComponentHandle ||
        variant.sizeComponentTitle ||
        variant.sizeComponentImage
      )
    }

    return !!(
      variant.colorComponentHandle ||
      variant.colorComponentTitle ||
      variant.colorComponentImage ||
      variant.colorSwatchHex ||
      variant.colorSwatchImage
    )
  }

  function hasSerializedComponentCoverage(type) {
    const optionKey = type === "size" ? "size" : "color"
    const options = getUniqueOptionValues(optionKey)
    if (!options.length) return false

    return options.every((optionValue) =>
      variantMap.some(
        (variant) =>
          optionValuesMatch(variant && variant[optionKey], optionValue) &&
          variantHasSerializedComponentData(variant, type),
      ),
    )
  }

  function getUniqueOptionValues(optionKey) {
    return [
      ...new Set(
        variantMap.map((variant) => variant[optionKey]).filter(Boolean),
      ),
    ]
  }

  function componentNameLooksLikeWrapper(name) {
    if (!name) return true
    if (/bundle/i.test(name)) return true
    return variantMap.some((variant) => optionValuesMatch(variant.title, name))
  }

  function componentImageLooksLikeWrapper(imageUrl, handle) {
    if (!imageUrl) return false
    if (handle && handle !== getBaseHandle(handle)) return false

    return variantMap.some((variant) => {
      const variantImage =
        variant &&
        variant.components &&
        variant.components[0] &&
        variant.components[0].image
          ? variant.components[0].image
          : ""
      return variantImage && variantImage === imageUrl
    })
  }

  function handleLooksLikeBundleWrapper(handle) {
    if (!handle) return false
    if (/bundle/i.test(handle)) return true

    return variantMap.some((variant) => {
      if (!variant || !variant.handle) return false
      return (
        variant.handle === handle || getBaseHandle(variant.handle) === handle
      )
    })
  }

  function getBaseHandle(handle) {
    if (!handle) return ""
    const parts = String(handle).split("-")
    if (parts.length <= 2) return handle
    return parts.slice(0, -1).join("-")
  }

  function getLabelSwatchHex(label) {
    const slug = slugify(label || "")
    return LABEL_SWATCH_HEX[slug] || ""
  }

  function ensureColorSwatchFallbacks(component, options) {
    if (!component || !options || !options.length) return
    if (!component.swatches) component.swatches = {}

    options.forEach((option) => {
      const hex = getLabelSwatchHex(option)
      if (!hex || component.swatches[option]) return
      component.swatches[option] = {
        hex,
        imageUrl: "",
        label: option,
      }
    })
  }

  function shouldSkipSelfComponentDiscovery() {
    if (
      hasSerializedComponentCoverage("size") &&
      hasSerializedComponentCoverage("color")
    ) {
      return true
    }
    return false
  }

  function applyComponentFallbacks() {
    const stateVersion = activeStateVersion
    const popup = getActivePopup()
    const colors = getUniqueOptionValues("color")
    if (colorComponent && colors.length) {
      ensureColorSwatchFallbacks(colorComponent, colors)
    }
    if (popup && colorComponent && colorComponent.handle) {
      fetchPdpColorDataIfNeeded(popup)
    }

    const asyncFetches = []
    const shouldPrefetchExclusive =
      colors.length &&
      colorComponent &&
      colors.some((color) => exclusiveByColor[slugify(color)] === undefined)

    if (
      sizeComponent &&
      sizeComponent.allHandles &&
      sizeComponent.allHandles.length &&
      !sizeComponent.deferVariantImageFetch
    ) {
      asyncFetches.push(
        fetchAllVariantImages(sizeComponent, "size").catch(() => {}),
      )
    }
    if (
      colorComponent &&
      colorComponent.allHandles &&
      colorComponent.allHandles.length &&
      !colorComponent.deferVariantImageFetch
    ) {
      asyncFetches.push(
        fetchAllVariantImages(colorComponent, "color").catch(() => {}),
      )
    }
    if (shouldPrefetchExclusive) {
      asyncFetches.push(detectExclusiveFromColorComponent().catch(() => false))
    }

    if (asyncFetches.length) {
      Promise.all(asyncFetches).then(() => {
        if (isStaleState(stateVersion)) return
        if (popup && popup.getAttribute("aria-hidden") === "false") {
          applyComponentData(popup)
          updateComponentImages(popup)
          updateExclusiveLabel(popup)
          updateExtraExclusiveLabel(popup)
        }
      })
    }
  }

  /**
   * Build sizeComponent / colorComponent from server-rendered data
   * embedded in the variant map's `components` arrays.
   * Returns true if preloaded data was used (skips cart-based discovery).
   */
  function loadPreloadedComponents() {
    const stateVersion = activeStateVersion
    if (!variantMap.length) return false

    const first = variantMap.find(
      (v) => v.components && v.components.length && !v.components[0].isSelf,
    )
    if (!first) {
      return loadPreloadedSelfComponents()
    }

    const sizes = [...new Set(variantMap.map((v) => v.size).filter(Boolean))]
    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]
    const comps = first.components

    const hasUsableData = comps.some(
      (c) => c.handle && c.handle !== first.handle && (c.title || c.image),
    )
    if (!hasUsableData) return false

    const SIZE_TERMS = new Set([
      "short",
      "regular",
      "long",
      "small",
      "medium",
      "large",
      "xs",
      "s",
      "m",
      "l",
      "xl",
      "xxl",
      "one-size",
      "extra-small",
      "extra-large",
      "xx-large",
    ])

    let sizeIdx = -1
    let colorIdx = -1

    function findComponentIndexForOptionKey(optionKey) {
      if (comps.length <= 1) return -1

      for (let i = 0; i < comps.length; i++) {
        const optionToHandle = Object.create(null)
        let isConsistent = true
        let sawMatch = false

        for (const variant of variantMap) {
          const optionValue = variant[optionKey]
          const component =
            variant.components && variant.components[i]
              ? variant.components[i]
              : null

          if (!optionValue || !component || !component.handle) continue
          sawMatch = true

          if (optionToHandle[optionValue]) {
            if (optionToHandle[optionValue] !== component.handle) {
              isConsistent = false
              break
            }
          } else {
            optionToHandle[optionValue] = component.handle
          }
        }

        if (!isConsistent || !sawMatch) continue

        const uniqueHandles = Object.values(optionToHandle).filter(Boolean)
        const dedupedHandles = [...new Set(uniqueHandles)]
        if (dedupedHandles.length > 1) return i
      }

      return -1
    }

    if (isDualSizeMode) {
      if (sizes.length > 1) {
        sizeIdx = findComponentIndexForOptionKey("size")
      }
      if (colors.length > 1) {
        colorIdx = findComponentIndexForOptionKey("color")
      }
    } else {
      for (let i = 0; i < comps.length; i++) {
        if (comps[i].hasSize && sizeIdx < 0) {
          sizeIdx = i
        } else if (comps[i].hasColor && colorIdx < 0) {
          colorIdx = i
        }
      }

      if (sizeIdx < 0 && sizes.length > 1) {
        sizeIdx = findComponentIndexForOptionKey("size")
      }
      if (colorIdx < 0 && colors.length > 1) {
        colorIdx = findComponentIndexForOptionKey("color")
      }
    }

    if (isDualSizeMode && (sizeIdx < 0 || colorIdx < 0)) {
      const firstSizeSlug = slugify(sizes[0] || "")
      const firstColorSlug = slugify(colors[0] || "")
      for (let i = 0; i < comps.length; i++) {
        const sizeValueSlug = slugify(comps[i].sizeValue || "")
        if (sizeIdx < 0 && firstSizeSlug && sizeValueSlug === firstSizeSlug) {
          sizeIdx = i
          continue
        }
        if (
          colorIdx < 0 &&
          firstColorSlug &&
          sizeValueSlug === firstColorSlug
        ) {
          colorIdx = i
        }
      }
    }

    if (sizeIdx < 0 && colorIdx < 0) {
      for (let i = 0; i < comps.length; i++) {
        const parts = comps[i].handle.split("-")
        const last = parts[parts.length - 1].toLowerCase()
        if (SIZE_TERMS.has(last) && sizeIdx < 0) {
          sizeIdx = i
        } else if (colorIdx < 0) {
          colorIdx = i
        }
      }
    }

    if (sizeIdx < 0 && sizes.length > 0 && comps.length === 1) sizeIdx = 0
    if (colorIdx < 0 && colors.length > 0) {
      colorIdx = comps.findIndex((_, i) => i !== sizeIdx)
      if (colorIdx < 0 && comps.length === 1 && sizeIdx < 0) colorIdx = 0
    }

    function buildComponent(compIdx, options, optionKey) {
      if (compIdx < 0 || !options.length) return null
      const ref = comps[compIdx]
      const allHandles = []
      const images = {}
      const titles = {}
      const swatches = {}
      const seen = new Set()

      for (const v of variantMap) {
        const opt = v[optionKey]
        if (!opt || seen.has(opt) || !v.components) continue
        seen.add(opt)
        const match =
          v.components[compIdx] ||
          v.components.find(
            (c) => c.hasSize === ref.hasSize && c.hasColor === ref.hasColor,
          )
        if (match) {
          allHandles.push({ option: opt, handle: match.handle })
          if (match.image) images[opt] = match.image
          if (match.title) titles[opt] = match.title
          if (match.colorHex || match.colorImage) {
            swatches[opt] = {
              hex: match.colorHex || "",
              imageUrl: match.colorImage || "",
              label: match.colorLabel || "",
            }
          }
        }
      }

      const firstHandle = allHandles.length ? allHandles[0].handle : ref.handle
      const firstOpt = options[0]
      const slug = slugify(firstOpt)
      const base = firstHandle.endsWith("-" + slug)
        ? firstHandle.slice(0, -(slug.length + 1))
        : firstHandle

      return {
        name: ref.title || "",
        handle: firstHandle,
        baseHandle: base,
        defaultImage: ref.image || null,
        images,
        titles,
        swatches,
        swatchImages: {},
        allHandles,
        generation: ref.generation || "",
      }
    }

    sizeComponent = buildComponent(sizeIdx, sizes, "size")
    if (!sizeComponent && sizeIdx < 0 && sizes.length > 0 && comps.length > 1) {
      let fallbackSizeIdx = -1
      for (let i = comps.length - 1; i >= 0; i--) {
        if (i !== colorIdx) {
          fallbackSizeIdx = i
          break
        }
      }
      sizeComponent = buildComponent(fallbackSizeIdx, sizes, "size")
    }
    if (shouldPreferSizeHintComponent(sizes, sizeComponent)) {
      sizeComponent = buildHintedSingleProductComponent(
        sizeComponentHint,
        sizes,
      )
    }
    colorComponent = buildComponent(colorIdx, colors, "color")

    if (!sizeComponent && !colorComponent) return false

    componentDataReady = true
    enrichmentDone = true
    componentDataPromise = Promise.resolve()

    const popup = getActivePopup()
    if (sizeComponent && sizeComponent.singleProduct) {
      fetchAllVariantImages(sizeComponent, "size")
        .then(() => {
          if (isStaleState(stateVersion)) return
          if (popup && popup.getAttribute("aria-hidden") === "false") {
            updateComponentImages(popup)
          }
        })
        .catch(() => {})
    }
    if (popup && !isDualSizeMode) {
      fetchPdpColorDataIfNeeded(popup)
    }
    if (!isDualSizeMode) detectExclusiveFromColorComponent()

    return true
  }

  /**
   * Handle title-fallback or bundles where components[0].isSelf is true.
   * The child product IS the component — build objects from variant map handles.
   */
  function loadPreloadedSelfComponents() {
    const stateVersion = activeStateVersion
    const sizes = [...new Set(variantMap.map((v) => v.size).filter(Boolean))]
    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]

    if (colors.length > 0) {
      const images = {}
      const allHandles = []
      const titles = {}
      const swatches = {}
      const seen = new Set()
      for (const v of variantMap) {
        if (!v.color || seen.has(v.color)) continue
        seen.add(v.color)
        const comp =
          v.components && v.components[0]
            ? v.components[0]
            : { handle: v.handle }
        const handle = v.colorComponentHandle || comp.handle || v.handle
        allHandles.push({ option: v.color, handle })
        const image = v.colorComponentImage || comp.image || ""
        if (image && !componentImageLooksLikeWrapper(image, handle)) {
          images[v.color] = image
        }
        const title = v.colorComponentTitle || comp.title || ""
        if (title && !componentNameLooksLikeWrapper(title)) {
          titles[v.color] = title
        }
        if (v.colorSwatchHex || v.colorSwatchImage) {
          swatches[v.color] = {
            hex: v.colorSwatchHex || "",
            imageUrl: v.colorSwatchImage || "",
            label: v.colorSwatchLabel || v.color,
          }
        }
      }
      const ch = allHandles[0] ? allHandles[0].handle : ""
      const cs = slugify(colors[0])
      const base =
        ch && cs && ch.endsWith("-" + cs) ? ch.slice(0, -(cs.length + 1)) : ch
      colorComponent = {
        name: "",
        handle: ch,
        baseHandle: base || ch,
        defaultImage: null,
        images,
        titles,
        swatches,
        swatchImages: {},
        allHandles,
        deferVariantImageFetch: true,
        generation:
          (variantMap[0] && variantMap[0].colorComponentGeneration) || "",
      }
    }

    if (sizes.length > 0 && sizeComponentHint && sizeComponentHint.handle) {
      sizeComponent = buildHintedSingleProductComponent(
        sizeComponentHint,
        sizes,
      )
    } else if (sizes.length > 0) {
      const images = {}
      const allHandles = []
      const seen = new Set()
      for (const v of variantMap) {
        if (!v.size || seen.has(v.size)) continue
        seen.add(v.size)
        const comp =
          v.components && v.components[0]
            ? v.components[0]
            : { handle: v.handle }
        allHandles.push({ option: v.size, handle: comp.handle || v.handle })
        if (
          comp.image &&
          !componentImageLooksLikeWrapper(comp.image, comp.handle || v.handle)
        ) {
          images[v.size] = comp.image
        }
      }
      const ch = allHandles[0] ? allHandles[0].handle : ""
      const cs = slugify(sizes[0])
      const base =
        ch && cs && ch.endsWith("-" + cs) ? ch.slice(0, -(cs.length + 1)) : ch
      sizeComponent = {
        name: "",
        handle: ch,
        baseHandle: base || ch,
        defaultImage: null,
        images,
        titles: {},
        swatches: {},
        swatchImages: {},
        allHandles,
        deferVariantImageFetch: true,
      }
    }

    if (!sizeComponent && !colorComponent) return false

    if (colorComponent && colors.length) {
      ensureColorSwatchFallbacks(colorComponent, colors)
    }

    if (isMultiDim) {
      var extras = [...new Set(variantMap.map((v) => v.extra).filter(Boolean))]
      if (extras.length > 0) {
        extraComponent = {
          name: "",
          handle: variantMap[0].handle,
          baseHandle: "",
          defaultImage: null,
          images: {},
          titles: {},
          swatches: {},
          swatchImages: {},
          allHandles: extras
            .map(function (e) {
              var v = variantMap.find(function (x) {
                return x.extra === e
              })
              return v && v.handle ? { option: e, handle: v.handle } : null
            })
            .filter(Boolean),
        }
        if (!selectedExtra && extras.length) selectedExtra = extras[0]
      }
    }

    componentDataReady = true
    componentDataPromise = Promise.resolve()

    if (shouldSkipSelfComponentDiscovery()) {
      enrichmentDone = true
      return true
    }

    enrichmentPromise = enrichSelfComponentsFromChildData(stateVersion)
      .then(function () {
        if (isStaleState(stateVersion)) return
        fetchComponentImagesInBackground(stateVersion)
        if (
          isMultiDim &&
          extraComponent &&
          !extraComponentHasData(extraComponent)
        ) {
          return recoverExtraComponentData(stateVersion)
        }
      })
      .then(function () {
        if (isStaleState(stateVersion)) return
        enrichmentDone = true
        var popup = getActivePopup()
        correctColorLabelsFromEnrichedData(popup)
        correctExtraLabelsFromEnrichedData(popup)
        if (popup) {
          popup.classList.remove("is-loading")
          clearLoadingState(popup)
          if (popup.getAttribute("aria-hidden") === "false") {
            applyToOpenPopup()
          }
        }
      })
      .catch(function () {
        if (isStaleState(stateVersion)) return
        enrichmentDone = true
        var popup = getActivePopup()
        if (popup) {
          popup.classList.remove("is-loading")
          clearLoadingState(popup)
        }
      })

    return true
  }

  /**
   * After preloading components, still fetch PDP color data (swatch
   * corrections) in the background. This is fast and non-blocking.
   */
  function fetchPdpColorDataIfNeeded(popup) {
    const stateVersion = activeStateVersion
    if (isDualSizeMode || !colorComponent || !colorComponent.handle) return
    fetchColorDataFromPDP(colorComponent.handle)
      .then((pdpColors) => {
        if (isStaleState(stateVersion)) return
        if (pdpColors && pdpColors.length) {
          pdpColorData = mapPdpColorsToLabels(pdpColors)
          if (popup.getAttribute("aria-hidden") === "false") {
            correctColorLabels(popup)
            applyPdpSwatches(popup)
          }
        }
      })
      .catch(() => {})
  }

  function getPopupLocale() {
    return (
      (typeof Shopify !== "undefined" && Shopify.locale) ||
      document.documentElement.lang ||
      "en"
    )
      .split("-")[0]
      .toLowerCase()
  }

  function getLocalizedRootPath() {
    const root =
      typeof Shopify !== "undefined" && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/"
    return root.endsWith("/") ? root : root + "/"
  }

  function getSizeChartLocaleKey() {
    return getLocalizedRootPath()
  }

  function getSizeChartMarkupCacheKey(handle) {
    return getSizeChartLocaleKey() + handle
  }

  function getLocalizedProductPath(handle) {
    return getLocalizedRootPath() + "products/" + handle
  }

  function getCurrentColorKey(popup) {
    const activeColorBtn =
      popup && popup.querySelector(COLOR_BTN_SELECTOR + ".is-active")
    const value =
      selectedColor ||
      (activeColorBtn && activeColorBtn.dataset.optionValue) ||
      ""
    return value ? slugify(value) : ""
  }

  function getCurrentExtraKey(popup) {
    const activeExtraBtn =
      popup && popup.querySelector(EXTRA_BTN_SELECTOR + ".is-active")
    const value =
      selectedExtra ||
      (activeExtraBtn && activeExtraBtn.dataset.optionValue) ||
      ""
    return value ? slugify(value) : ""
  }

  function updateExclusiveLabel(popup) {
    if (!popup) return
    const label = popup.querySelector("[data-color-option-label]")
    if (!label) return
    if (isDualSizeMode) {
      label.textContent = (label.dataset.defaultLabel || "SIZE").trim() + ":"
      return
    }
    if (!defaultColorLabelText) {
      var raw = (
        label.getAttribute("data-default-label") || label.textContent
      ).trim()
      defaultColorLabelText = raw.replace(/:$/, "") + ":"
    }
    const locale = getPopupLocale()
    const colorKey = getCurrentColorKey(popup)
    const isExclusive = colorKey && exclusiveByColor[colorKey] === true
    label.textContent = isExclusive
      ? (EXCLUSIVE_LABELS[locale] || EXCLUSIVE_LABELS.en) + ":"
      : defaultColorLabelText
  }

  function updateExtraExclusiveLabel(popup) {
    if (!popup || !isMultiDim) return
    const label = popup.querySelector("[data-extra-option-label]")
    if (!label) return
    if (!defaultExtraLabelText) {
      var raw = (
        label.getAttribute("data-default-label") || label.textContent
      ).trim()
      defaultExtraLabelText = raw.replace(/:$/, "") + ":"
    }
    const locale = getPopupLocale()
    const extraKey = getCurrentExtraKey(popup)
    const isExclusive = extraKey && exclusiveByExtra[extraKey] === true
    label.textContent = isExclusive
      ? (EXCLUSIVE_LABELS[locale] || EXCLUSIVE_LABELS.en) + ":"
      : defaultExtraLabelText
  }

  function productPageIsExclusive(handle) {
    if (!handle) return Promise.resolve(false)
    if (handleLooksLikeBundleWrapper(handle)) return Promise.resolve(false)
    if (handle in exclusiveHandleCache)
      return Promise.resolve(exclusiveHandleCache[handle])
    return fetch("/products/" + handle + "?section_id=exclusive-badge-check")
      .then(function (r) {
        return r.text()
      })
      .then(function (text) {
        var result = text.indexOf("EXCLUSIVE_TRUE") !== -1
        exclusiveHandleCache[handle] = result
        return result
      })
      .catch(function () {
        return false
      })
  }

  function detectExclusiveFromHandles(handles) {
    const uniqueHandles = [...new Set((handles || []).filter(Boolean))]
    if (!uniqueHandles.length) return Promise.resolve(false)

    return Promise.all(
      uniqueHandles.map((handle) => productPageIsExclusive(handle)),
    )
      .then((results) => results.some(Boolean))
      .catch(() => false)
  }

  function detectExclusiveFromColorComponent() {
    if (!colorComponent) return Promise.resolve(false)
    const entries =
      colorComponent.allHandles && colorComponent.allHandles.length
        ? colorComponent.allHandles
        : colorComponent.handle
          ? [{ option: selectedColor || "", handle: colorComponent.handle }]
          : []

    return Promise.all(
      entries.map((entry) => {
        const resolvedHandle =
          getColorHandleForOption(entry.option) || entry.handle || ""
        return detectExclusiveFromHandles([resolvedHandle]).then((result) => {
          if (entry.option) exclusiveByColor[slugify(entry.option)] = result
          return result
        })
      }),
    ).then((results) => {
      updateExclusiveLabel(getActivePopup())
      return results.some(Boolean)
    })
  }

  function detectExclusiveFromExtraComponent() {
    if (!extraComponent || !isMultiDim) return Promise.resolve(false)
    const entries =
      extraComponent.allHandles && extraComponent.allHandles.length
        ? extraComponent.allHandles
        : extraComponent.handle
          ? [{ option: selectedExtra || "", handle: extraComponent.handle }]
          : []

    return Promise.all(
      entries.map((entry) => {
        const resolvedHandle = entry.handle || ""
        return detectExclusiveFromHandles([resolvedHandle]).then((result) => {
          if (entry.option) exclusiveByExtra[slugify(entry.option)] = result
          return result
        })
      }),
    ).then((results) => {
      updateExtraExclusiveLabel(getActivePopup())
      return results.some(Boolean)
    })
  }

  function prefetchExclusiveDirectForExtra() {
    if (!isMultiDim) return Promise.resolve()
    var extraHandles = []
    var seen = Object.create(null)
    for (var i = 0; i < variantMap.length; i++) {
      var v = variantMap[i]
      var e = v.extra
      if (!e || seen[e]) continue
      seen[e] = true
      var handle =
        (extraComponent && getExactHandleForOption(extraComponent, e)) ||
        v.handle
      if (!handle || handleLooksLikeBundleWrapper(handle)) continue
      extraHandles.push({ extra: e, handle: handle })
    }
    if (!extraHandles.length) return Promise.resolve()
    return Promise.all(
      extraHandles.map(function (entry) {
        return productPageIsExclusive(entry.handle).then(function (result) {
          exclusiveByExtra[slugify(entry.extra)] = result
        })
      }),
    )
      .then(function () {
        updateExtraExclusiveLabel(getActivePopup())
      })
      .catch(function () {})
  }

  function detectExclusiveFromCartSection(sectionHtml, color, variantId) {
    let htmlToParse = sectionHtml || ""
    if (variantId) {
      const rowMatches = htmlToParse.match(/<tr\b[\s\S]*?<\/tr>/g) || []
      const variantNeedle = 'data-variant-id="' + String(variantId) + '"'
      const matchedRow = rowMatches.find((rowHtml) =>
        rowHtml.includes(variantNeedle),
      )
      if (matchedRow) htmlToParse = matchedRow
    }
    const doc = new DOMParser().parseFromString(htmlToParse, "text/html")
    const handles = [...doc.querySelectorAll("[data-comp-url]")]
      .map((el) => {
        const url = el.dataset.compUrl || ""
        return url.split("/products/").pop().split("?")[0]
      })
      .filter(Boolean)

    return detectExclusiveFromHandles(handles).then((result) => {
      if (color) exclusiveByColor[slugify(color)] = result
      updateExclusiveLabel(getActivePopup())
      return result
    })
  }

  function detectExclusiveFromCart(color) {
    if (!color) return prefetchExclusiveDirect().then(() => false)

    var handle =
      getColorHandleForOption(color) ||
      (colorComponent && getExactHandleForOption(colorComponent, color)) ||
      ""
    if (!handle || handleLooksLikeBundleWrapper(handle)) {
      exclusiveByColor[slugify(color)] = false
      updateExclusiveLabel(getActivePopup())
      return Promise.resolve(false)
    }

    return productPageIsExclusive(handle).then(function (result) {
      exclusiveByColor[slugify(color)] = result
      updateExclusiveLabel(getActivePopup())
      return result
    })
  }

  function prefetchExclusiveDirect() {
    var colorHandles = []
    var seen = Object.create(null)
    for (var i = 0; i < variantMap.length; i++) {
      var v = variantMap[i]
      var c = v.color
      if (!c || seen[c]) continue
      seen[c] = true
      var handle =
        getColorHandleForOption(c) ||
        (colorComponent && getExactHandleForOption(colorComponent, c)) ||
        v.handle
      if (!handle || handleLooksLikeBundleWrapper(handle)) continue
      colorHandles.push({ color: c, handle: handle })
    }
    if (!colorHandles.length) return Promise.resolve()
    return Promise.all(
      colorHandles.map(function (entry) {
        return productPageIsExclusive(entry.handle).then(function (result) {
          exclusiveByColor[slugify(entry.color)] = result
        })
      }),
    )
      .then(function () {
        updateExclusiveLabel(getActivePopup())
      })
      .catch(function () {})
  }

  function prefetchExclusiveFromCartByColor() {
    if (isTitleFallback) return prefetchExclusiveDirect()
    var colors = [
      ...new Set(
        variantMap
          .map(function (v) {
            return v.color
          })
          .filter(Boolean),
      ),
    ]
    if (!colors.length) return Promise.resolve()
    return Promise.all(
      colors.map(function (color) {
        return detectExclusiveFromCart(color)
      }),
    ).then(function () {})
  }

  /**
   * Fetch the bundle-component-data section for a child bundle handle.
   * Returns an array of component objects with full metafield data.
   */
  var childComponentCache = Object.create(null)

  function isCartRateLimited() {
    return cartRateLimitUntil > Date.now()
  }

  function setCartRateLimitCooldown(delayMs) {
    cartRateLimitUntil = Date.now() + Math.max(delayMs || 4000, 1000)
  }

  function getSelfEntryCacheKey(entry) {
    if (!entry) return ""
    return [
      entry.variantId || "",
      slugify(entry.size || ""),
      slugify(entry.color || ""),
    ].join("::")
  }

  function fetchChildBundleComponentData(handle) {
    if (!handle) return Promise.resolve([])
    if (handle in childComponentCache)
      return Promise.resolve(childComponentCache[handle])

    // WEBD-1281: hydrate memory cache from localStorage so repeat visits are instant
    var persistedKey = "comp::" + handle
    var persisted = readBundleCache(persistedKey)
    if (persisted && Array.isArray(persisted)) {
      childComponentCache[handle] = persisted
      // Still refresh in background so cache stays fresh, but resolve immediately.
      fetchChildBundleComponentDataLive(handle, persistedKey).catch(
        function () {},
      )
      return Promise.resolve(persisted)
    }

    return fetchChildBundleComponentDataLive(handle, persistedKey)
  }

  function fetchChildBundleComponentDataLive(handle, persistedKey) {
    return fetch("/products/" + handle + "?section_id=bundle-component-data")
      .then(function (r) {
        return r.text()
      })
      .then(function (text) {
        var marker = "BUNDLE_COMPONENT_JSON:"
        var idx = text.indexOf(marker)
        if (idx < 0) {
          childComponentCache[handle] = []
          return []
        }
        var jsonStr = text.slice(idx + marker.length).trim()
        var endTag = jsonStr.indexOf("</div>")
        if (endTag >= 0) jsonStr = jsonStr.slice(0, endTag).trim()
        try {
          var comps = JSON.parse(jsonStr)
          childComponentCache[handle] = comps
          // Only persist when we actually got real component data (not just wrapper isSelf).
          var hasReal = (comps || []).some(function (c) {
            return c && !c.isSelf
          })
          if (hasReal && persistedKey) writeBundleCache(persistedKey, comps)
          return comps
        } catch (e) {
          childComponentCache[handle] = []
          return []
        }
      })
      .catch(function () {
        childComponentCache[handle] = []
        return []
      })
  }

  /**
   * Discover actual component handles from a single cart add/remove cycle.
   * Returns an array of { handle, title } for each component found.
   */
  function discoverComponentHandlesFromCart(variantId) {
    if (!variantId) return Promise.resolve([])

    // WEBD-1281: skip the 2-3s cart add/remove cycle if we've discovered
    // these components before (per variant). Refresh in background.
    var cacheKey = "cartdisc::" + variantId
    var persisted = readBundleCache(cacheKey)
    if (persisted && Array.isArray(persisted) && persisted.length) {
      discoverComponentHandlesFromCartLive(variantId, cacheKey).catch(
        function () {},
      )
      return Promise.resolve(persisted)
    }

    if (isCartRateLimited()) return Promise.resolve([])
    return discoverComponentHandlesFromCartLive(variantId, cacheKey)
  }

  function discoverComponentHandlesFromCartLive(variantId, cacheKey) {
    if (isCartRateLimited()) return Promise.resolve([])

    return fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: CART_SECTION_ID,
      }),
    })
      .then(function (r) {
        if (r.status === 429) {
          setCartRateLimitCooldown()
          return null
        }
        if (!r.ok) throw new Error(r.status)
        return r.json()
      })
      .then(function (data) {
        if (!data) return []
        var handles = []
        var addedItemKey = data && data.key ? data.key : ""
        var addedVariantId =
          data && data.variant_id ? data.variant_id : variantId
        var comps =
          data.item_components ||
          (data.items && data.items[0] && data.items[0].item_components) ||
          []
        if (comps && comps.length) {
          comps.forEach(function (comp) {
            var compUrl = comp.url || ""
            var handle = compUrl.split("/products/").pop().split("?")[0]
            if (!handle) return
            var title = (comp.title || "").replace(/^\d+\s*[×x]\s*/, "").trim()
            var imageUrl = comp.image || comp.featured_image || ""
            if (typeof imageUrl === "object" && imageUrl.src)
              imageUrl = imageUrl.src
            handles.push({ handle: handle, title: title, imageUrl: imageUrl })
          })
        }

        if (
          !handles.length &&
          data.sections &&
          data.sections[CART_SECTION_ID]
        ) {
          var doc = new DOMParser().parseFromString(
            data.sections[CART_SECTION_ID],
            "text/html",
          )
          var rows = doc.querySelectorAll("tr.cart-item")
          var matchedRow = null
          var keyNeedle = addedItemKey
            ? 'data-cart-item-key="' + addedItemKey + '"'
            : ""
          var variantNeedle = 'data-variant-id="' + String(addedVariantId) + '"'

          for (var i = 0; i < rows.length; i++) {
            var rowHtml = rows[i].outerHTML || ""
            if (keyNeedle && rowHtml.indexOf(keyNeedle) >= 0) {
              matchedRow = rows[i]
              break
            }
            if (rowHtml.indexOf(variantNeedle) >= 0) {
              matchedRow = rows[i]
              break
            }
          }

          var targetRow =
            matchedRow || (rows.length ? rows[rows.length - 1] : doc)
          var compEls = targetRow.querySelectorAll("[data-comp-url]")
          compEls.forEach(function (el) {
            var url = el.dataset.compUrl || ""
            var handle = url.split("/products/").pop().split("?")[0]
            if (!handle) return
            var titleEl = el.querySelector(".cart-item__bundle-comp-title")
            var imgEl = el.querySelector(".cart-item__bundle-comp-img")
            var title = titleEl
              ? titleEl.textContent.replace(/^\d+\s*[×x]\s*/, "").trim()
              : ""
            var imageUrl = imgEl ? imgEl.getAttribute("src") || "" : ""
            handles.push({ handle: handle, title: title, imageUrl: imageUrl })
          })
        }

        return handles
      })
      .then(function (handles) {
        if (handles && handles.length && cacheKey) {
          writeBundleCache(cacheKey, handles)
        }
        return removeDiscoveryItem(variantId).then(function () {
          return handles
        })
      })
      .catch(function () {
        return []
      })
  }

  function getEquivalentOptionSlugs(optionValue) {
    var base = slugify(optionValue || "")
    if (!base) return []

    var slugs = Object.create(null)
    slugs[base] = true

    if (base === "xxl" || base === "xx-large") {
      slugs.xxl = true
      slugs["xx-large"] = true
    }
    if (base === "xl" || base === "x-large") {
      slugs.xl = true
      slugs["x-large"] = true
    }
    if (base === "xs" || base === "x-small" || base === "extra-small") {
      slugs.xs = true
      slugs["x-small"] = true
      slugs["extra-small"] = true
    }
    if (base === "s" || base === "small") {
      slugs.s = true
      slugs.small = true
    }
    if (base === "m" || base === "medium") {
      slugs.m = true
      slugs.medium = true
    }
    if (base === "l" || base === "large") {
      slugs.l = true
      slugs.large = true
    }

    return Object.keys(slugs)
  }

  function componentMatchesOptionValue(comp, optionValue) {
    if (!comp || !optionValue) return false

    var needles = getEquivalentOptionSlugs(optionValue)
    if (!needles.length) return false

    var haystacks = [
      slugify(comp.handle || ""),
      slugify(comp.title || ""),
    ].filter(Boolean)

    return haystacks.some(function (hay) {
      return needles.some(function (needle) {
        return (
          hay === needle ||
          hay.indexOf("-" + needle) >= 0 ||
          hay.indexOf(needle + "-") >= 0 ||
          hay.indexOf(needle) >= 0
        )
      })
    })
  }

  function normalizeComponentDisplayTitle(title, optionValue) {
    var normalizedTitle = (title || "").trim()
    if (!normalizedTitle) return ""

    var parenMatch = normalizedTitle.match(/\(([^)]+)\)\s*$/)
    if (parenMatch && optionValuesMatch(parenMatch[1], optionValue)) {
      normalizedTitle = normalizedTitle.slice(0, parenMatch.index).trim()
    }

    return normalizedTitle
  }

  function getPrioritizedSelfEntries(entries) {
    if (!entries || !entries.length) return []

    var resolvedVariant = getResolvedVariant()
    if (!resolvedVariant || !resolvedVariant.variantId) {
      return entries.slice()
    }

    var prioritized = []
    var remaining = []

    entries.forEach(function (entry) {
      if (entry.variantId === resolvedVariant.variantId) {
        prioritized.push(entry)
      } else {
        remaining.push(entry)
      }
    })

    return prioritized.concat(remaining)
  }

  function applyEnrichedSelfComponentResults(results, stateVersion) {
    if (isStaleState(stateVersion) || !results || !results.length) {
      return
    }
    var popup = getActivePopup()
    var selectedColorHandle = ""

    results.forEach(function (result, resultIdx) {
      var entry = result.entry
      var comps = result.comps
      if (!comps || !comps.length) return

      var colorComp = null
      var sizeComp = null
      var extraComp = null
      if (isDualSizeMode) {
        var sizeLike = comps.filter(function (c) {
          return c && !c.isSelf && c.hasSize
        })
        sizeComp = sizeLike[0] || null
        colorComp = sizeLike[1] || null
      }
      for (var i = 0; i < comps.length; i++) {
        var c = comps[i]
        if (c.isSelf) continue
        if (!sizeComp && c.hasSize) {
          sizeComp = c
          continue
        }
        if (!colorComp && !c.hasSize) {
          colorComp = c
          continue
        }
        if (isMultiDim && !extraComp && !c.hasSize && c !== colorComp) {
          extraComp = c
          continue
        }
        if (isMultiDim && !extraComp && c !== sizeComp && c !== colorComp) {
          extraComp = c
          continue
        }
      }
      if (isMultiDim) {
        for (var ui = 0; ui < comps.length; ui++) {
          var uc = comps[ui]
          if (
            uc.isSelf ||
            uc === sizeComp ||
            uc === colorComp ||
            uc === extraComp
          )
            continue
          if (!colorComp) {
            colorComp = uc
          } else if (!sizeComp) {
            sizeComp = uc
          }
          break
        }
      }
      if (resultIdx === 0) {
      }
      if (isMultiDim && colorComp && extraComp && entry.color && entry.extra) {
        var cSlugTest = handleSlugify(entry.color)
        var eSlugTest = handleSlugify(entry.extra)
        var colorHandle = (colorComp.handle || "").toLowerCase()
        var extraHandle = (extraComp.handle || "").toLowerCase()
        var colorInColorH = cSlugTest && colorHandle.indexOf(cSlugTest) >= 0
        var extraInExtraH = eSlugTest && extraHandle.indexOf(eSlugTest) >= 0
        var extraInColorH = eSlugTest && colorHandle.indexOf(eSlugTest) >= 0
        var colorInExtraH = cSlugTest && extraHandle.indexOf(cSlugTest) >= 0
        if (
          !colorInColorH &&
          !extraInExtraH &&
          (extraInColorH || colorInExtraH)
        ) {
          var swapTmp = colorComp
          colorComp = extraComp
          extraComp = swapTmp
        }
      }
      if (!colorComp && comps.length > 0) {
        for (var i = 0; i < comps.length; i++) {
          if (!comps[i].isSelf && comps[i].colorLabel) {
            colorComp = comps[i]
            break
          }
        }
      }
      if (!colorComp && comps.length > 0) {
        for (var i = 0; i < comps.length; i++) {
          if (!comps[i].isSelf) {
            colorComp = comps[i]
            break
          }
        }
      }

      if (colorComp && entry.color && colorComponent) {
        var existingTitle = colorComponent.titles[entry.color]
        var existingImage = colorComponent.images[entry.color]
        var existingHandleEntry = null
        if (colorComponent.allHandles) {
          for (var hi = 0; hi < colorComponent.allHandles.length; hi++) {
            if (colorComponent.allHandles[hi].option === entry.color) {
              existingHandleEntry = colorComponent.allHandles[hi]
              break
            }
          }
        }
        var existingHandleIsGood = !!(
          existingHandleEntry &&
          existingHandleEntry.handle &&
          !handleLooksLikeBundleWrapper(existingHandleEntry.handle)
        )

        var displayTitle = normalizeComponentDisplayTitle(
          colorComp._componentTitle || colorComp.title,
          entry.color,
        )
        if (
          displayTitle &&
          (!existingTitle || componentNameLooksLikeWrapper(existingTitle))
        ) {
          colorComponent.titles[entry.color] = displayTitle
        }
        if (
          colorComp.image &&
          (!existingImage || componentImageLooksLikeWrapper(existingImage, ""))
        ) {
          colorComponent.images[entry.color] = colorComp.image
          colorComponent.deferVariantImageFetch = false
          if (!colorComponent.defaultImage)
            colorComponent.defaultImage = colorComp.image
        }
        if (
          colorComp.colorLabel ||
          colorComp.colorHex ||
          colorComp.colorImage
        ) {
          if (
            !colorComponent.swatches[entry.color] ||
            (!colorComponent.swatches[entry.color].hex &&
              !colorComponent.swatches[entry.color].imageUrl)
          ) {
            colorComponent.swatches[entry.color] = {
              hex: colorComp.colorHex || "",
              imageUrl: colorComp.colorImage || "",
              label: colorComp.colorLabel || entry.color,
            }
          }
        }
        if (colorComp.generation) {
          if (!colorComponent.generations)
            colorComponent.generations = Object.create(null)
          colorComponent.generations[entry.color] = colorComp.generation
          colorComponent.generation = colorComp.generation
        }
        if (colorComp.handle) {
          if (existingHandleEntry) {
            if (!existingHandleIsGood) {
              existingHandleEntry.handle = colorComp.handle
            }
          } else {
            colorComponent.allHandles.push({
              option: entry.color,
              handle: colorComp.handle,
            })
          }
          if (optionValuesMatch(entry.color, selectedColor)) {
            selectedColorHandle = existingHandleIsGood
              ? existingHandleEntry.handle
              : colorComp.handle
          }
        }

        exclusiveByColor[slugify(entry.color)] = !!colorComp.exclusiveBadge

        for (var vi = 0; vi < variantMap.length; vi++) {
          var vm = variantMap[vi]
          if (vm.handle !== entry.handle) continue
          if (
            !vm.colorComponentHandle ||
            handleLooksLikeBundleWrapper(vm.colorComponentHandle)
          ) {
            vm.colorComponentHandle = colorComp.handle || ""
          }
          if (
            !vm.colorComponentTitle ||
            componentNameLooksLikeWrapper(vm.colorComponentTitle)
          ) {
            vm.colorComponentTitle = displayTitle || colorComp.title || ""
          }
          if (
            !vm.colorComponentImage ||
            componentImageLooksLikeWrapper(vm.colorComponentImage, "")
          ) {
            vm.colorComponentImage = colorComp.image || ""
          }
          vm.colorComponentGeneration =
            vm.colorComponentGeneration || colorComp.generation || ""
          if (!vm.colorSwatchLabel)
            vm.colorSwatchLabel = colorComp.colorLabel || ""
          if (!vm.colorSwatchHex) vm.colorSwatchHex = colorComp.colorHex || ""
          if (!vm.colorSwatchImage)
            vm.colorSwatchImage = colorComp.colorImage || ""
          if (!vm.components) vm.components = []
          if (
            vm.components.length <= 1 &&
            vm.components[0] &&
            vm.components[0].isSelf
          ) {
            vm.components = comps.filter(function (x) {
              return !x.isSelf
            })
          }
        }
      }

      if (sizeComp && entry.size && sizeComponent) {
        var sizeDisplayTitle = normalizeComponentDisplayTitle(
          sizeComp._componentTitle || sizeComp.title,
          entry.size,
        )
        if (!sizeComponent.titles) sizeComponent.titles = Object.create(null)
        if (sizeDisplayTitle) {
          var existingSizeTitle = sizeComponent.titles[entry.size]
          if (
            !existingSizeTitle ||
            componentNameLooksLikeWrapper(existingSizeTitle)
          ) {
            sizeComponent.titles[entry.size] = sizeDisplayTitle
          }
        }
        if (sizeComp.image) {
          var existingSizeImage = sizeComponent.images[entry.size]
          if (
            !existingSizeImage ||
            componentImageLooksLikeWrapper(existingSizeImage, "")
          ) {
            sizeComponent.images[entry.size] = sizeComp.image
            sizeComponent.deferVariantImageFetch = false
            if (!sizeComponent.defaultImage)
              sizeComponent.defaultImage = sizeComp.image
          }
        }
        if (sizeComp.generation) {
          if (!sizeComponent.generations)
            sizeComponent.generations = Object.create(null)
          sizeComponent.generations[entry.size] = sizeComp.generation
          sizeComponent.generation = sizeComp.generation
        }
        if (sizeComp.hasSizeChart && sizeComp.sizeChartHandle) {
          if (!sizeComponent.sizeChartHandles)
            sizeComponent.sizeChartHandles = Object.create(null)
          sizeComponent.sizeChartHandles[entry.size] = sizeComp.sizeChartHandle
          if (
            !sizeComponent.handle ||
            sizeComponent.handle === sizeComp.sizeChartHandle
          ) {
            sizeComponent.handle = sizeComp.sizeChartHandle
          }
        }
        if (sizeComp.handle) {
          if (!sizeComponent.allHandles) sizeComponent.allHandles = []
          var sExist = false
          var sExistGood = false
          for (var sj = 0; sj < sizeComponent.allHandles.length; sj++) {
            if (sizeComponent.allHandles[sj].option === entry.size) {
              sExist = true
              sExistGood = !!(
                sizeComponent.allHandles[sj].handle &&
                !handleLooksLikeBundleWrapper(
                  sizeComponent.allHandles[sj].handle,
                )
              )
              if (!sExistGood) {
                sizeComponent.allHandles[sj].handle = sizeComp.handle
              }
              break
            }
          }
          if (!sExist) {
            sizeComponent.allHandles.push({
              option: entry.size,
              handle: sizeComp.handle,
            })
          }
        }
      }

      if (isMultiDim && extraComp && entry.extra && extraComponent) {
        exclusiveByExtra[slugify(entry.extra)] = !!extraComp.exclusiveBadge

        var extraDisplayTitle = normalizeComponentDisplayTitle(
          extraComp._componentTitle || extraComp.title,
          entry.extra,
        )
        if (extraDisplayTitle && !extraComponent.titles[entry.extra]) {
          extraComponent.titles[entry.extra] = extraDisplayTitle
        }
        if (extraComp.image && !extraComponent.images[entry.extra]) {
          extraComponent.images[entry.extra] = extraComp.image
          if (!extraComponent.defaultImage)
            extraComponent.defaultImage = extraComp.image
        }
        if (
          extraComp.colorLabel ||
          extraComp.colorHex ||
          extraComp.colorImage
        ) {
          if (!extraComponent.swatches[entry.extra]) {
            extraComponent.swatches[entry.extra] = {
              hex: extraComp.colorHex || "",
              imageUrl: extraComp.colorImage || "",
              label: extraComp.colorLabel || entry.extra,
            }
          }
        }
        if (extraComp.generation) {
          if (!extraComponent.generations)
            extraComponent.generations = Object.create(null)
          extraComponent.generations[entry.extra] = extraComp.generation
          extraComponent.generation = extraComp.generation
        }
        if (extraComp.handle) {
          var eExist = false
          for (var ei = 0; ei < extraComponent.allHandles.length; ei++) {
            if (extraComponent.allHandles[ei].option === entry.extra) {
              eExist = true
              if (
                handleLooksLikeBundleWrapper(
                  extraComponent.allHandles[ei].handle,
                )
              ) {
                extraComponent.allHandles[ei].handle = extraComp.handle
              }
              break
            }
          }
          if (!eExist) {
            extraComponent.allHandles.push({
              option: entry.extra,
              handle: extraComp.handle,
            })
          }
        }
        if (
          !extraComponent.name &&
          extraComp._componentTitle &&
          !componentNameLooksLikeWrapper(extraComp._componentTitle)
        ) {
          extraComponent.name = extraComp._componentTitle
        }
        if (!handleLooksLikeBundleWrapper(extraComp.handle || "")) {
          if (
            !extraComponent.handle ||
            handleLooksLikeBundleWrapper(extraComponent.handle)
          ) {
            extraComponent.handle = extraComp.handle
            extraComponent.baseHandle = extraComp.handle
          }
        }
      }
    })

    if (popup) {
      injectFindMySizeIfNeeded(popup)
      updateExclusiveLabel(popup)
      updateExtraExclusiveLabel(popup)
      if (popup.getAttribute("aria-hidden") === "false") {
        applyComponentData(popup)
        applyVariantMapDerivedComponentData(popup)
        applySerializedColorSwatches(popup)
        applySerializedExtraSwatches(popup)
        applyVariantMapColorSwatches(popup)
        updateComponentImages(popup)
        updateGenerationTags(popup)
      }
    }

    if (selectedColorHandle && !isDualSizeMode) {
      hydrateColorComponentFromPdp(selectedColorHandle, stateVersion)
    }
  }

  function discoverEntriesFromCartSequentially(entries, mapFn) {
    var results = []
    var chain = Promise.resolve()

    entries.forEach(function (entry) {
      chain = chain
        .then(function () {
          return mapFn(entry)
        })
        .then(function (result) {
          results.push(result)
        })
    })

    return chain.then(function () {
      return results
    })
  }

  function buildSelfEntryResultFromCartHandles(entry, compHandles) {
    if (!entry) return { entry: entry, comps: [] }
    if (!compHandles || !compHandles.length) {
      return { entry: entry, comps: [] }
    }

    if (isDualSizeMode) {
      var primaryComp =
        compHandles.find(function (comp) {
          return componentMatchesOptionValue(comp, entry.size)
        }) || compHandles[0]
      var secondaryComp =
        compHandles.find(function (comp) {
          return (
            comp !== primaryComp &&
            componentMatchesOptionValue(comp, entry.color)
          )
        }) ||
        compHandles.find(function (comp) {
          return comp !== primaryComp
        }) ||
        compHandles[1] ||
        null

      var ordered = []
      if (primaryComp) {
        ordered.push({
          handle: primaryComp.handle || "",
          title: normalizeComponentDisplayTitle(
            primaryComp.title || "",
            entry.size,
          ),
          image: primaryComp.imageUrl || "",
          generation: "",
          colorLabel: "",
          colorHex: "",
          colorImage: "",
          hasSize: true,
          hasColor: false,
          sizeValue: entry.size || "",
          hasSizeChart: false,
          sizeChartHandle: "",
          exclusiveBadge: false,
          isSelf: false,
        })
      }
      if (secondaryComp) {
        ordered.push({
          handle: secondaryComp.handle || "",
          title: normalizeComponentDisplayTitle(
            secondaryComp.title || "",
            entry.color,
          ),
          image: secondaryComp.imageUrl || "",
          generation: "",
          colorLabel: "",
          colorHex: "",
          colorImage: "",
          hasSize: true,
          hasColor: false,
          sizeValue: entry.color || "",
          hasSizeChart: false,
          sizeChartHandle: "",
          exclusiveBadge: false,
          isSelf: false,
        })
      }

      return { entry: entry, comps: ordered }
    }

    var normalizedComps = compHandles.map(function (comp) {
      var matchesSize = componentMatchesOptionValue(comp, entry.size)
      var matchesColor = componentMatchesOptionValue(comp, entry.color)
      return {
        handle: comp.handle || "",
        title: normalizeComponentDisplayTitle(
          comp.title || "",
          matchesSize ? entry.size : entry.color,
        ),
        image: comp.imageUrl || "",
        generation: "",
        colorLabel: "",
        colorHex: "",
        colorImage: "",
        hasSize: matchesSize,
        hasColor: matchesColor,
        sizeValue: matchesSize ? entry.size || "" : "",
        hasSizeChart: false,
        sizeChartHandle: "",
        exclusiveBadge: false,
        isSelf: false,
      }
    })

    if (normalizedComps.length === 2) {
      var sizeIndex = normalizedComps.findIndex(function (comp) {
        return comp.hasSize
      })
      var colorIndex = normalizedComps.findIndex(function (comp) {
        return comp.hasColor
      })

      if (sizeIndex < 0 && colorIndex >= 0) {
        var inferredSizeIndex = colorIndex === 0 ? 1 : 0
        normalizedComps[inferredSizeIndex].hasSize = true
        normalizedComps[inferredSizeIndex].sizeValue = entry.size || ""
      } else if (colorIndex < 0 && sizeIndex >= 0) {
        var inferredColorIndex = sizeIndex === 0 ? 1 : 0
        normalizedComps[inferredColorIndex].hasColor = true
        normalizedComps[inferredColorIndex].colorLabel = entry.color || ""
      } else if (sizeIndex < 0 && colorIndex < 0) {
        normalizedComps[0].hasSize = true
        normalizedComps[0].sizeValue = entry.size || ""
        normalizedComps[1].hasColor = true
        normalizedComps[1].colorLabel = entry.color || ""
      }
    }

    return { entry: entry, comps: normalizedComps }
  }

  function buildSelfEntryResultFromComponentData(entry, comps) {
    if (!entry) return { entry: entry, comps: [] }
    if (!comps || !comps.length) return { entry: entry, comps: [] }

    return {
      entry: entry,
      comps: comps.filter(function (comp) {
        return comp && !comp.isSelf
      }),
    }
  }

  function currentSelectionNeedsSelfRefresh() {
    var sizeDetail = getVariantComponentDetail("size", selectedSize)
    var colorDetail = getVariantComponentDetail("color", selectedColor)

    if (!isDualSizeMode) {
      return (
        !colorDetail ||
        colorDetail.isWrapperFallback ||
        !colorDetail.title ||
        !colorDetail.image
      )
    }

    var sizeNeeds =
      !sizeDetail ||
      sizeDetail.isWrapperFallback ||
      !sizeDetail.title ||
      !sizeDetail.image
    var colorNeeds =
      !colorDetail ||
      colorDetail.isWrapperFallback ||
      !colorDetail.title ||
      !colorDetail.image

    return sizeNeeds || colorNeeds
  }

  function refreshCurrentSelfVariantIfNeeded() {
    if (shouldSkipSelfComponentDiscovery()) return
    if (!currentSelectionNeedsSelfRefresh()) return

    var resolvedVariant = getResolvedVariant()
    if (!resolvedVariant || !resolvedVariant.variantId) return

    var entry = {
      handle: resolvedVariant.handle || "",
      color: resolvedVariant.color || selectedColor || "",
      size: resolvedVariant.size || selectedSize || "",
      extra: resolvedVariant.extra || selectedExtra || "",
      variantId: resolvedVariant.variantId,
    }
    var stateVersion = activeStateVersion
    var cacheKey = getSelfEntryCacheKey(entry)
    if (cacheKey && selfEntryResultCache[cacheKey]) {
      applyEnrichedSelfComponentResults(
        [selfEntryResultCache[cacheKey]],
        stateVersion,
      )
      return
    }

    selfEntryDiscoveryQueue = selfEntryDiscoveryQueue
      .then(function () {
        if (cacheKey && selfEntryRequestCache[cacheKey]) {
          return selfEntryRequestCache[cacheKey]
        }

        var request = fetchChildBundleComponentData(entry.handle)
          .then(function (comps) {
            return buildSelfEntryResultFromComponentData(entry, comps)
          })
          .then(function (result) {
            if (cacheKey && result && result.comps && result.comps.length) {
              selfEntryResultCache[cacheKey] = result
            }
            return result
          })
          .finally(function () {
            if (cacheKey) delete selfEntryRequestCache[cacheKey]
          })

        if (cacheKey) selfEntryRequestCache[cacheKey] = request
        return request
      })
      .then(function (result) {
        applyEnrichedSelfComponentResults([result], stateVersion)
      })
      .catch(function () {})
  }

  function discoverKnownSelfEntriesFromCart(entries, stateVersion) {
    if (!entries || !entries.length) return Promise.resolve([])

    var prioritizedEntries = getPrioritizedSelfEntries(entries)
    var firstEntry = prioritizedEntries[0]

    return fetchChildBundleComponentData(firstEntry.handle).then(
      function (comps) {
        var realComps = (comps || []).filter(function (c) {
          return !c.isSelf
        })
        if (realComps.length > 0) {
          var firstResult = buildSelfEntryResultFromComponentData(
            firstEntry,
            comps,
          )
          var backgroundEntries = prioritizedEntries.slice(1)

          if (backgroundEntries.length) {
            Promise.all(
              backgroundEntries.map(function (entry) {
                return fetchChildBundleComponentData(entry.handle).then(
                  function (c) {
                    return buildSelfEntryResultFromComponentData(entry, c)
                  },
                )
              }),
            )
              .then(function (backgroundResults) {
                applyEnrichedSelfComponentResults(
                  [firstResult].concat(backgroundResults),
                  stateVersion,
                )
              })
              .catch(function () {})
          }

          return [firstResult]
        }

        return discoverComponentHandlesFromCart(firstEntry.variantId)
          .then(function (compHandles) {
            if (!compHandles || !compHandles.length) return []

            return Promise.all(
              compHandles.map(function (comp) {
                return fetchChildBundleComponentData(comp.handle).then(
                  function (sectionData) {
                    var allEntries = (sectionData || []).filter(function (e) {
                      return !e.isSelf
                    })
                    var sData =
                      allEntries.find(function (e) {
                        return e.handle === comp.handle
                      }) ||
                      allEntries[0] ||
                      (sectionData && sectionData[0]) ||
                      {}
                    var isActuallySelf =
                      !allEntries.length &&
                      sectionData &&
                      sectionData.length === 1 &&
                      sectionData[0].isSelf
                    return {
                      handle: comp.handle,
                      title: sData.title || comp.title || "",
                      image: sData.image || comp.imageUrl || "",
                      generation: sData.generation || "",
                      colorLabel: sData.colorLabel || "",
                      colorHex: sData.colorHex || "",
                      colorImage: sData.colorImage || "",
                      hasSize: sData.hasSize || false,
                      sizeValue: sData.sizeValue || "",
                      hasSizeChart: sData.hasSizeChart || false,
                      sizeChartHandle: sData.sizeChartHandle || "",
                      exclusiveBadge: sData.exclusiveBadge || false,
                      isSelf: !!isActuallySelf,
                      _componentTitle: sData.title || comp.title || "",
                      _allColorEntries:
                        allEntries.length > 1 ? allEntries : null,
                    }
                  },
                )
              }),
            )
          })
          .then(function (discoveredComps) {
            if (!discoveredComps || !discoveredComps.length) return []

            return buildExtrapolatedResults(
              discoveredComps,
              firstEntry,
              prioritizedEntries,
            )
          })
      },
    )
  }

  function colorLabelsMatch(bundleColor, sectionLabel) {
    if (!bundleColor || !sectionLabel) return false
    var a = bundleColor.toLowerCase().trim()
    var b = sectionLabel.toLowerCase().trim()
    if (a === b) return true
    if (a.endsWith(" " + b)) return true
    if (a.endsWith("-" + b)) return true
    if (handleSlugify(bundleColor) === handleSlugify(sectionLabel)) return true
    return false
  }

  function buildExtrapolatedResults(discoveredComps, firstEntry, allEntries) {
    var realComps = discoveredComps.filter(function (c) {
      return !c.isSelf
    })
    if (!realComps.length) realComps = discoveredComps

    var sizeComp = realComps.find(function (c) {
      return c.hasSize
    })
    var colorComp = null
    var extraComp = null
    var nonSizeComps = realComps.filter(function (c) {
      return !c.isSelf && !c.hasSize
    })
    if (isMultiDim && nonSizeComps.length >= 2) {
      colorComp = nonSizeComps[0]
      extraComp = nonSizeComps[1]
      if (firstEntry && firstEntry.color && firstEntry.extra) {
        var cSlugBuild = handleSlugify(firstEntry.color)
        var eSlugBuild = handleSlugify(firstEntry.extra)
        var cH = (colorComp.handle || "").toLowerCase()
        var eH = (extraComp.handle || "").toLowerCase()
        var cInC = cSlugBuild && cH.indexOf(cSlugBuild) >= 0
        var eInE = eSlugBuild && eH.indexOf(eSlugBuild) >= 0
        var eInC = eSlugBuild && cH.indexOf(eSlugBuild) >= 0
        var cInE = cSlugBuild && eH.indexOf(cSlugBuild) >= 0
        if (!cInC && !eInE && (eInC || cInE)) {
          var tmpSwap = colorComp
          colorComp = extraComp
          extraComp = tmpSwap
        }
      }
    } else if (
      isMultiDim &&
      nonSizeComps.length === 1 &&
      realComps.length >= 3
    ) {
      colorComp = nonSizeComps[0]
      extraComp =
        realComps.find(function (c) {
          return !c.isSelf && c !== sizeComp && c !== colorComp
        }) || null
    } else {
      colorComp = realComps.find(function (c) {
        return (
          !c.isSelf &&
          !c.hasSize &&
          (c.colorLabel || c.colorHex || c._allColorEntries)
        )
      })
      if (!colorComp) {
        colorComp = realComps.find(function (c) {
          return !c.isSelf && !c.hasSize
        })
      }
      if (!colorComp && realComps.length === 1) {
        colorComp = realComps[0]
      } else if (!colorComp && realComps.length > 1) {
        colorComp = realComps[realComps.length > 1 ? 1 : 0] || null
      }
    }

    if (isMultiDim && !extraComp && realComps.length >= 3) {
      extraComp =
        realComps.find(function (c) {
          return !c.isSelf && c !== sizeComp && c !== colorComp
        }) || null
    }
    if (isMultiDim && realComps.length >= 3) {
      var remainingComp = realComps.find(function (c) {
        return !c.isSelf && c !== sizeComp && c !== colorComp && c !== extraComp
      })
      if (remainingComp) {
        if (!sizeComp) sizeComp = remainingComp
        else if (!colorComp) colorComp = remainingComp
      }
    }

    var colorEntryMap = null
    var colorEntryByHandleSuffix = Object.create(null)
    if (
      colorComp &&
      colorComp._allColorEntries &&
      colorComp._allColorEntries.length > 1
    ) {
      colorEntryMap = Object.create(null)
      colorComp._allColorEntries.forEach(function (entry) {
        if (entry.colorLabel) {
          colorEntryMap[entry.colorLabel.toLowerCase().trim()] = entry
        }
        if (entry.handle) {
          var parts = entry.handle.split("-")
          var suffix = parts[parts.length - 1].toLowerCase()
          if (suffix && !colorEntryByHandleSuffix[suffix]) {
            colorEntryByHandleSuffix[suffix] = entry
          }
        }
      })
    }

    function deriveBaseHandle(comp, optionValue) {
      if (!comp || !comp.handle || !optionValue) return comp ? comp.handle : ""
      var slug = handleSlugify(optionValue)
      if (slug && comp.handle.endsWith("-" + slug)) {
        return comp.handle.slice(0, -(slug.length + 1))
      }
      return comp.handle
    }

    function findColorEntry(bundleColor, bundleHandle) {
      if (!colorEntryMap || !bundleColor) return null
      var key = bundleColor.toLowerCase().trim()
      if (colorEntryMap[key]) return colorEntryMap[key]
      var parts = key.split(/\s+/)
      var lastWord = parts[parts.length - 1]
      if (lastWord && colorEntryMap[lastWord]) return colorEntryMap[lastWord]
      var hSlug = handleSlugify(bundleColor)
      for (var k in colorEntryMap) {
        if (handleSlugify(k) === hSlug) return colorEntryMap[k]
      }
      for (var k in colorEntryMap) {
        if (k.indexOf(key) === 0 || handleSlugify(k).indexOf(hSlug) === 0) {
          return colorEntryMap[k]
        }
      }
      var colorSuffix = hSlug.split("-").pop()
      if (colorSuffix && colorEntryByHandleSuffix[colorSuffix]) {
        return colorEntryByHandleSuffix[colorSuffix]
      }
      if (bundleHandle) {
        var handleSuffix = bundleHandle.split("-").pop().toLowerCase()
        if (handleSuffix && colorEntryByHandleSuffix[handleSuffix]) {
          return colorEntryByHandleSuffix[handleSuffix]
        }
      }
      return null
    }

    var extraEntryMap = null
    var extraEntryByHandleSuffix = Object.create(null)
    if (
      isMultiDim &&
      extraComp &&
      extraComp._allColorEntries &&
      extraComp._allColorEntries.length > 1
    ) {
      extraEntryMap = Object.create(null)
      extraComp._allColorEntries.forEach(function (entry) {
        if (entry.colorLabel) {
          extraEntryMap[entry.colorLabel.toLowerCase().trim()] = entry
        }
        if (entry.handle) {
          var parts = entry.handle.split("-")
          var suffix = parts[parts.length - 1].toLowerCase()
          if (suffix && !extraEntryByHandleSuffix[suffix]) {
            extraEntryByHandleSuffix[suffix] = entry
          }
        }
      })
    }

    function findExtraEntry(bundleExtra, bundleHandle) {
      if (!extraEntryMap || !bundleExtra) return null
      var key = bundleExtra.toLowerCase().trim()
      if (extraEntryMap[key]) return extraEntryMap[key]
      var parts = key.split(/\s+/)
      var lastWord = parts[parts.length - 1]
      if (lastWord && extraEntryMap[lastWord]) return extraEntryMap[lastWord]
      var hSlug = handleSlugify(bundleExtra)
      for (var k in extraEntryMap) {
        if (handleSlugify(k) === hSlug) return extraEntryMap[k]
      }
      for (var k in extraEntryMap) {
        if (k.indexOf(key) === 0 || handleSlugify(k).indexOf(hSlug) === 0) {
          return extraEntryMap[k]
        }
      }
      var extraSuffix = hSlug.split("-").pop()
      if (extraSuffix && extraEntryByHandleSuffix[extraSuffix]) {
        return extraEntryByHandleSuffix[extraSuffix]
      }
      if (bundleHandle) {
        var handleSuffix = bundleHandle.split("-").pop().toLowerCase()
        if (handleSuffix && extraEntryByHandleSuffix[handleSuffix]) {
          return extraEntryByHandleSuffix[handleSuffix]
        }
      }
      return null
    }

    var sizeBase = sizeComp ? deriveBaseHandle(sizeComp, firstEntry.size) : ""
    var colorBase = colorComp
      ? deriveBaseHandle(colorComp, firstEntry.color)
      : ""

    var singleComponentForBothDims =
      isDualSizeMode && sizeComp && colorComp === sizeComp

    return allEntries.map(function (entry) {
      var comps = []

      if (sizeComp) {
        var sSlug = handleSlugify(entry.size || "")
        var sHandle =
          sizeBase && sSlug && sizeBase !== sizeComp.handle
            ? sizeBase + "-" + sSlug
            : sizeComp.handle
        comps.push(
          Object.assign({}, sizeComp, {
            handle: sHandle,
            sizeValue: entry.size || "",
            isSelf: false,
            _allColorEntries: null,
          }),
        )
      }

      if (colorComp && !singleComponentForBothDims) {
        var matchedEntry = findColorEntry(entry.color, entry.handle)
        if (matchedEntry) {
          comps.push(
            Object.assign({}, matchedEntry, {
              isSelf: false,
              _componentTitle:
                matchedEntry.title || colorComp._componentTitle || "",
              _allColorEntries: null,
            }),
          )
        } else {
          var cSlug = handleSlugify(entry.color || "")
          var cHandle =
            colorBase && cSlug && colorBase !== colorComp.handle
              ? colorBase + "-" + cSlug
              : colorComp.handle
          comps.push(
            Object.assign({}, colorComp, {
              handle: cHandle,
              isSelf: false,
              _allColorEntries: null,
              colorLabel: "",
              colorHex: "",
              colorImage: "",
            }),
          )
        }
      } else if (singleComponentForBothDims) {
        comps.push(
          Object.assign({}, sizeComp, {
            handle: comps[0] ? comps[0].handle : sizeComp.handle,
            hasSize: true,
            hasColor: false,
            sizeValue: entry.color || "",
            isSelf: false,
            _allColorEntries: null,
          }),
        )
      }

      if (isMultiDim && extraComp) {
        var matchedExtra = findExtraEntry(entry.extra, entry.handle)
        if (matchedExtra) {
          comps.push(
            Object.assign({}, matchedExtra, {
              isSelf: false,
              _componentTitle:
                matchedExtra.title || extraComp._componentTitle || "",
              _allColorEntries: null,
            }),
          )
        } else {
          var extraBase = deriveBaseHandle(extraComp, firstEntry.extra || "")
          var eSlug = handleSlugify(entry.extra || "")
          var eHandle =
            extraBase && eSlug && extraBase !== extraComp.handle
              ? extraBase + "-" + eSlug
              : extraComp.handle
          comps.push(
            Object.assign({}, extraComp, {
              handle: eHandle,
              isSelf: false,
              _allColorEntries: null,
              colorLabel: "",
              colorHex: "",
              colorImage: "",
            }),
          )
        }
      }

      return { entry: entry, comps: comps }
    })
  }

  /**
   * For self-component bundles (isSelf=true), fetch real component data.
   * Step 1: Try section API for each child handle (fast, parallel).
   * Step 2: If all return isSelf, discover component handles via one cart
   *         add/remove, then fetch section for each actual component handle.
   *         Components that have product_group return ALL color variants at
   *         once, so we match each popup option to the correct variant.
   */
  function variantNeedsEnrichment(v) {
    var needsColor = colorComponent && getUniqueOptionValues("color").length > 0
    var needsSize = sizeComponent && getUniqueOptionValues("size").length > 0
    var hasGoodColor = !!(
      v.colorComponentHandle &&
      !handleLooksLikeBundleWrapper(v.colorComponentHandle)
    )
    var hasGoodSize = !!(
      v.sizeComponentHandle &&
      !handleLooksLikeBundleWrapper(v.sizeComponentHandle)
    )
    if ((!needsColor || hasGoodColor) && (!needsSize || hasGoodSize))
      return false
    return true
  }

  function enrichSelfComponentsFromChildData(stateVersion) {
    var entries = []
    var seen = Object.create(null)
    for (var i = 0; i < variantMap.length; i++) {
      var v = variantMap[i]
      if (!v.handle || seen[v.handle]) continue
      seen[v.handle] = true
      if (!variantNeedsEnrichment(v)) continue
      entries.push({
        handle: v.handle,
        color: v.color || "",
        size: v.size || "",
        extra: v.extra || "",
        variantId: v.variantId,
      })
    }
    if (!entries.length) return Promise.resolve()

    var knownSelfOnly = variantMap.every(function (variant) {
      return (
        !variant.components ||
        !variant.components.length ||
        (variant.components.length === 1 && variant.components[0].isSelf)
      )
    })
    if (knownSelfOnly) {
      return discoverKnownSelfEntriesFromCart(entries, stateVersion).then(
        function (results) {
          applyEnrichedSelfComponentResults(results, stateVersion)
        },
      )
    }

    // WEBD-1281: Fetch the selected bundle variant first; component handles
    // usually differ from bundle child handles, so match against variant data.
    var resolvedVariant = getResolvedVariant()
    var selectedVariantEntry =
      entries.find(function (e) {
        return (
          resolvedVariant &&
          resolvedVariant.variantId &&
          String(e.variantId) === String(resolvedVariant.variantId)
        )
      }) ||
      entries.find(function (e) {
        return (
          resolvedVariant &&
          resolvedVariant.handle &&
          e.handle === resolvedVariant.handle
        )
      }) ||
      entries[0]

    var priorityEntries = selectedVariantEntry ? [selectedVariantEntry] : []
    var backgroundEntries = entries.filter(function (e) {
      return priorityEntries.indexOf(e) === -1
    })

    // Fetch priority (selected) variant first
    var priorityFetch = Promise.all(
      priorityEntries.map(function (entry) {
        return fetchChildBundleComponentData(entry.handle).then(
          function (comps) {
            return { entry: entry, comps: comps }
          },
        )
      }),
    ).catch(function () {
      return [] // If priority fails, continue anyway
    })

    // Fetch background variants without blocking modal
    priorityFetch.then(function (priorityResults) {
      // WEBD-1281: Apply selected variant immediately (don't wait for allSelf check)
      applyEnrichedSelfComponentResults(priorityResults, stateVersion)

      // Fetch remaining in background (doesn't block modal)
      Promise.all(
        backgroundEntries.map(function (entry) {
          return fetchChildBundleComponentData(entry.handle).then(
            function (comps) {
              return { entry: entry, comps: comps }
            },
          )
        }),
      )
        .then(function (backgroundResults) {
          var allResults = priorityResults.concat(backgroundResults)
          // Update with full results when background fetches complete
          applyEnrichedSelfComponentResults(allResults, stateVersion)
        })
        .catch(function () {
          // Silently fail - modal is already open with selected variant data
        })
    })

    return priorityFetch
  }

  function hasSizeChartForComponent(component, optionValue) {
    if (!component) return false
    if (
      component.sizeChartHandles &&
      optionValue &&
      component.sizeChartHandles[optionValue]
    ) {
      return true
    }
    return !!(component.baseHandle || component.handle)
  }

  function extraOptionActsLikeSize(popup) {
    return !!(isMultiDim && popup && popup.dataset.extraOptionIsSize === "true")
  }

  function ensureFindMySizeLink(popup, optionType) {
    var group = popup.querySelector(
      '.bundle-options-popup__option-group[data-option-type="' +
        optionType +
        '"]',
    )
    if (!group || group.querySelector("[data-bundle-open-size-chart]")) return

    var header = group.querySelector(".bundle-options-popup__option-header")
    if (!header) return

    var wrap = document.createElement("div")
    wrap.className = "bundle-options-popup__find-size-wrap"
    var btn = document.createElement("button")
    btn.type = "button"
    btn.className = "bundle-options-popup__find-size-link"
    btn.setAttribute("data-bundle-open-size-chart", optionType)
    btn.textContent =
      window.theme && window.theme.strings && window.theme.strings.find_my_size
        ? window.theme.strings.find_my_size
        : "Find my size"
    wrap.appendChild(btn)
    header.appendChild(wrap)
  }

  function injectFindMySizeIfNeeded(popup) {
    var canShowPrimary =
      hasSizeChartForComponent(sizeComponent, selectedSize) ||
      !!(
        (sizeComponentHint && sizeComponentHint.handle) ||
        (popup && popup.dataset.sizeComponentHintHandle)
      )

    if (canShowPrimary) {
      ensureFindMySizeLink(popup, "size")
    }

    if (
      isDualSizeMode &&
      hasSizeChartForComponent(colorComponent, selectedColor)
    ) {
      ensureFindMySizeLink(popup, "color")
    }

    if (
      extraOptionActsLikeSize(popup) &&
      (hasSizeChartForComponent(extraComponent, selectedExtra) ||
        popup.dataset.extraSizeComponentHintHandle ||
        popup.dataset.secondarySizeComponentHintHandle)
    ) {
      ensureFindMySizeLink(popup, "extra")
    }

    initSizeChart(popup)
  }

  function buildComponentsFromSerializedVariantData() {
    var sizes = getUniqueOptionValues("size")
    var colors = getUniqueOptionValues("color")

    function findVariantForOption(type, optionValue) {
      if (!optionValue) return null
      if (type === "size") {
        return (
          findVariant(optionValue, selectedColor) ||
          variantMap.find(function (variant) {
            return optionValuesMatch(variant && variant.size, optionValue)
          })
        )
      }
      return (
        findVariant(selectedSize, optionValue) ||
        variantMap.find(function (variant) {
          return optionValuesMatch(variant && variant.color, optionValue)
        })
      )
    }

    function buildComponent(type, options) {
      if (!options.length) return null

      var handleKey =
        type === "size" ? "sizeComponentHandle" : "colorComponentHandle"
      var titleKey =
        type === "size" ? "sizeComponentTitle" : "colorComponentTitle"
      var imageKey =
        type === "size" ? "sizeComponentImage" : "colorComponentImage"
      var generationKey =
        type === "size" ? "sizeComponentGeneration" : "colorComponentGeneration"
      var allHandles = []
      var images = {}
      var titles = {}
      var swatches = {}
      var sizeChartHandles = Object.create(null)
      var generations = Object.create(null)
      var firstHandle = ""
      var firstGeneration = ""
      var defaultImage = null
      var name = ""

      options.forEach(function (optionValue) {
        var variant = findVariantForOption(type, optionValue)
        if (!variant) return

        var handle = variant[handleKey] || ""
        var title = variant[titleKey] || ""
        var image = variant[imageKey] || ""
        var generation = variant[generationKey] || ""

        if (handle) {
          allHandles.push({ option: optionValue, handle: handle })
          if (!firstHandle) firstHandle = handle
        }
        if (title) {
          titles[optionValue] = title
          if (!name && !componentNameLooksLikeWrapper(title)) name = title
        }
        if (image && !componentImageLooksLikeWrapper(image, handle)) {
          images[optionValue] = image
          if (!defaultImage) defaultImage = image
        }
        if (generation) {
          generations[optionValue] = generation
          if (!firstGeneration) firstGeneration = generation
        }

        var detail = getVariantComponentDetail(type, optionValue)
        if (
          type === "size" &&
          detail &&
          !detail.isWrapperFallback &&
          detail.hasSizeChart &&
          detail.sizeChartHandle
        ) {
          sizeChartHandles[optionValue] = detail.sizeChartHandle
        }

        if (type === "color") {
          if (
            variant.colorSwatchHex ||
            variant.colorSwatchImage ||
            variant.colorSwatchLabel
          ) {
            swatches[optionValue] = {
              hex: variant.colorSwatchHex || "",
              imageUrl: variant.colorSwatchImage || "",
              label: variant.colorSwatchLabel || optionValue,
            }
          }
        }
      })

      if (
        !firstHandle &&
        !name &&
        !defaultImage &&
        !Object.keys(swatches).length
      ) {
        return null
      }

      return {
        name: name || "",
        handle: firstHandle || "",
        baseHandle: firstHandle || "",
        defaultImage: defaultImage,
        images: images,
        titles: titles,
        swatches: swatches,
        swatchImages: {},
        allHandles: allHandles,
        sizeChartHandles: sizeChartHandles,
        generation: firstGeneration,
        generations: generations,
      }
    }

    if (!sizeComponent) {
      sizeComponent = buildComponent("size", sizes)
    }
    if (!colorComponent) {
      colorComponent = buildComponent("color", colors)
    }

    return !!(sizeComponent || colorComponent)
  }

  /* ------------------------------------------------------------------ */
  /*  Component discovery (fallback when preloaded data unavailable)     */
  /* ------------------------------------------------------------------ */

  function discoverComponents() {
    if (componentDataPromise) return componentDataPromise
    const stateVersion = activeStateVersion

    const firstVariant = variantMap[0]
    if (!firstVariant) return Promise.resolve()

    buildComponentsFromSerializedVariantData()

    if (
      componentHasUsableHandle(sizeComponent) ||
      componentHasUsableHandle(colorComponent)
    ) {
      componentDataReady = true
      applyToOpenPopup()

      componentDataPromise = Promise.all([
        componentHasUsableHandle(sizeComponent)
          ? fetchAllVariantImages(sizeComponent, "size")
          : null,
        componentHasUsableHandle(colorComponent)
          ? fetchAllVariantImages(colorComponent, "color")
          : null,
        colorComponent &&
        colorComponent.handle &&
        !handleLooksLikeBundleWrapper(colorComponent.handle)
          ? fetchColorDataFromPDP(colorComponent.handle).then((pdpColors) => {
              if (pdpColors && pdpColors.length) {
                pdpColorData = mapPdpColorsToLabels(pdpColors)
              }
            })
          : null,
      ])
        .then(() => {
          if (isStaleState(stateVersion)) return
          return retryMissingImagesWithPdpSlugs()
        })
        .then(() => {
          if (isStaleState(stateVersion)) return
          return detectExclusiveFromColorComponent()
        })
        .then(() => {
          if (isStaleState(stateVersion)) return
          componentDataReady = true
          enrichmentDone = true
          applyToOpenPopup()
        })
        .catch((err) => {
          if (isStaleState(stateVersion)) return
          console.error("Bundle component sync failed:", err)
          componentDataReady = true
          enrichmentDone = true
          applyToOpenPopup()
        })
      return componentDataPromise
    }

    /* Title-fallback bundles: product_group contains child bundle products
       (e.g. "Beauty Bundle (white)"). Skip cart-based discovery entirely —
       just fetch each child product's image directly from its handle. */
    if (isTitleFallback) {
      componentDataPromise = discoverTitleFallbackComponents()
      return componentDataPromise
    }

    componentDataPromise = Promise.resolve()
      .then(() => {
        if (isStaleState(stateVersion)) return
        componentDataReady = true
        enrichmentDone = true
        applyToOpenPopup()
      })
      .catch((err) => {
        if (isStaleState(stateVersion)) return
        console.error("Bundle component discovery failed:", err)
        componentDataReady = true
        enrichmentDone = true
        applyToOpenPopup()
      })

    return componentDataPromise
  }

  /**
   * For singleProduct color components, discover the actual component product
   * for each color by adding a different bundle variant (per color) to cart,
   * parsing the section HTML, and recording the handle + image.
   */
  function discoverColorComponentsFromCart() {
    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]
    if (!colors.length || !colorComponent) return Promise.resolve()

    const sizeCompBase = sizeComponent ? sizeComponent.baseHandle : null
    const sizeCompHandles = new Set()
    if (sizeComponent) {
      sizeCompHandles.add(sizeComponent.handle)
      if (sizeComponent.allHandles) {
        sizeComponent.allHandles.forEach((h) => sizeCompHandles.add(h.handle))
      }
    }

    function discoverForColor(color) {
      const variant =
        variantMap.find(
          (v) =>
            v.color === color && (!selectedSize || v.size === selectedSize),
        ) || variantMap.find((v) => v.color === color)
      if (!variant) return Promise.resolve()

      let discoveredHandle = null

      return addToCartWithSection(variant.variantId)
        .then((sectionHtml) => {
          if (!sectionHtml) return
          const parser = new DOMParser()
          const doc = parser.parseFromString(sectionHtml, "text/html")
          const compEls = doc.querySelectorAll("[data-comp-url]")

          compEls.forEach((el) => {
            const url = el.dataset.compUrl || ""
            const handle = url.split("/products/").pop().split("?")[0]
            if (!handle) return
            if (sizeCompHandles.has(handle)) return
            if (sizeCompBase && handle.startsWith(sizeCompBase + "-")) return

            discoveredHandle = handle

            if (!colorComponent.name) {
              const title = el.querySelector(".cart-item__bundle-comp-title")
              if (title) {
                colorComponent.name = title.textContent
                  .replace(/^\d+\s*[×x]\s*/, "")
                  .trim()
              }
            }

            if (!colorComponent.allHandles) colorComponent.allHandles = []
            colorComponent.allHandles.push({ option: color, handle: handle })
          })
        })
        .then(() => removeDiscoveryItem())
        .then(() => {
          if (!discoveredHandle) return
          return fetch("/products/" + discoveredHandle + ".js")
            .then((r) => {
              if (!r.ok) throw new Error(r.status)
              return r.json()
            })
            .then((product) => {
              const img = getBestProductImage(product)
              if (img && !colorComponent.images[color]) {
                colorComponent.images[color] = img
              }
              if (!colorComponent.name && product.title)
                colorComponent.name = product.title
            })
            .catch(() => {})
        })
    }

    let chain = Promise.resolve()
    colors.forEach((color) => {
      chain = chain.then(() => discoverForColor(color))
    })
    return chain.then(() => {
      colorComponent.singleProduct = false
      colorComponent._discoveredFromCart = true
      if (!colorComponent.defaultImage) {
        const firstImg = Object.values(colorComponent.images).find(Boolean)
        if (firstImg) colorComponent.defaultImage = firstImg
      }
    })
  }

  function discoverTitleFallbackComponents() {
    const stateVersion = activeStateVersion
    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]
    const sizes = [...new Set(variantMap.map((v) => v.size).filter(Boolean))]

    if (colors.length > 0) {
      colorComponent = {
        name: "",
        handle: variantMap[0].handle,
        baseHandle: "",
        defaultImage: null,
        images: {},
        titles: {},
        swatches: {},
        swatchImages: {},
        allHandles: colors
          .map((c) => {
            const v = variantMap.find((x) => x.color === c)
            return v && v.handle ? { option: c, handle: v.handle } : null
          })
          .filter(Boolean),
      }
    }

    if (sizes.length > 0) {
      sizeComponent = {
        name: "",
        handle: variantMap[0].handle,
        baseHandle: "",
        defaultImage: null,
        images: {},
        titles: {},
        swatches: {},
        swatchImages: {},
        allHandles: sizes
          .map((s) => {
            const v = variantMap.find((x) => x.size === s)
            return v && v.handle ? { option: s, handle: v.handle } : null
          })
          .filter(Boolean),
      }
    }

    if (isMultiDim) {
      var extras = [...new Set(variantMap.map((v) => v.extra).filter(Boolean))]
      if (extras.length > 0) {
        extraComponent = {
          name: "",
          handle: variantMap[0].handle,
          baseHandle: "",
          defaultImage: null,
          images: {},
          titles: {},
          swatches: {},
          swatchImages: {},
          allHandles: extras
            .map(function (e) {
              var v = variantMap.find(function (x) {
                return x.extra === e
              })
              return v && v.handle ? { option: e, handle: v.handle } : null
            })
            .filter(Boolean),
        }
        if (!selectedExtra && extras.length) selectedExtra = extras[0]
      }
    }

    componentDataReady = true

    enrichmentPromise = enrichSelfComponentsFromChildData(stateVersion)
      .then(() => {
        if (isStaleState(stateVersion)) return
        fetchComponentImagesInBackground(stateVersion)
        if (
          isMultiDim &&
          extraComponent &&
          !extraComponentHasData(extraComponent)
        ) {
          return recoverExtraComponentData(stateVersion)
        }
      })
      .then(() => {
        if (isStaleState(stateVersion)) return
        enrichmentDone = true
        var popup = getActivePopup()
        correctColorLabelsFromEnrichedData(popup)
        correctExtraLabelsFromEnrichedData(popup)
        if (popup) clearLoadingState(popup)
        applyToOpenPopup()
      })
      .catch((err) => {
        if (isStaleState(stateVersion)) return
        console.error("Title-fallback component discovery failed:", err)
        enrichmentDone = true
        var popup = getActivePopup()
        if (popup) clearLoadingState(popup)
        applyToOpenPopup()
      })

    return enrichmentPromise
  }

  function extraComponentHasData(comp) {
    if (!comp) return false
    if (comp.name) return true
    for (var k in comp.titles) {
      if (comp.titles[k]) return true
    }
    return false
  }

  function recoverExtraComponentData(stateVersion) {
    if (!extraComponent || !isMultiDim) return Promise.resolve()

    var extraValues = [
      ...new Set(
        variantMap
          .map(function (v) {
            return v.extra
          })
          .filter(Boolean),
      ),
    ]
    if (!extraValues.length) return Promise.resolve()

    var colorHandleBase = ""
    if (colorComponent && colorComponent.allHandles) {
      for (var i = 0; i < colorComponent.allHandles.length; i++) {
        var h = colorComponent.allHandles[i].handle
        if (h && !handleLooksLikeBundleWrapper(h)) {
          colorHandleBase = h
          break
        }
      }
    }

    var candidateHandles = []
    extraValues.forEach(function (val) {
      var slug = handleSlugify(val)
      if (!slug) return

      var existingHandle = null
      if (extraComponent.allHandles) {
        for (var i = 0; i < extraComponent.allHandles.length; i++) {
          if (extraComponent.allHandles[i].option === val) {
            existingHandle = extraComponent.allHandles[i].handle
            break
          }
        }
      }
      if (existingHandle && !handleLooksLikeBundleWrapper(existingHandle)) {
        candidateHandles.push({ option: val, handle: existingHandle })
        return
      }

      var discovered = false
      for (var vi = 0; vi < variantMap.length; vi++) {
        var vm = variantMap[vi]
        if (vm.extra !== val) continue
        if (vm.components && vm.components.length > 1) {
          for (var ci = 0; ci < vm.components.length; ci++) {
            var c = vm.components[ci]
            if (
              !c.isSelf &&
              !c.hasSize &&
              c.handle &&
              !handleLooksLikeBundleWrapper(c.handle)
            ) {
              var isColorComp = false
              if (colorComponent && colorComponent.allHandles) {
                for (var hi = 0; hi < colorComponent.allHandles.length; hi++) {
                  if (colorComponent.allHandles[hi].handle === c.handle) {
                    isColorComp = true
                    break
                  }
                }
              }
              if (!isColorComp) {
                candidateHandles.push({ option: val, handle: c.handle })
                discovered = true
                break
              }
            }
          }
        }
        if (discovered) break
      }
    })

    if (!candidateHandles.length) {
      var firstExtraVal = extraValues[0]
      var firstExtraEntry = variantMap.find(function (v) {
        return v.extra === firstExtraVal
      })
      if (!firstExtraEntry) return Promise.resolve()

      var childHandle = firstExtraEntry.handle || ""
      var childSectionPromise = childHandle
        ? fetchChildBundleComponentData(childHandle)
        : Promise.resolve([])

      return childSectionPromise
        .then(function (comps) {
          var nonSelf = (comps || []).filter(function (c) {
            return !c.isSelf
          })
          if (nonSelf.length >= 2) return nonSelf

          var mainHandle = (window.location.pathname || "").split(
            "/products/",
          )[1]
          if (mainHandle) mainHandle = mainHandle.split("/")[0].split("?")[0]
          if (!mainHandle || !firstExtraEntry.variantId) return nonSelf

          var mainUrl =
            "/products/" +
            mainHandle +
            "?variant=" +
            firstExtraEntry.variantId +
            "&section_id=bundle-component-data"
          return fetch(mainUrl)
            .then(function (r) {
              return r.text()
            })
            .then(function (text) {
              var marker = "BUNDLE_COMPONENT_JSON:"
              var idx = text.indexOf(marker)
              if (idx < 0) return nonSelf
              var jsonStr = text.slice(idx + marker.length).trim()
              var endTag = jsonStr.indexOf("</div>")
              if (endTag >= 0) jsonStr = jsonStr.slice(0, endTag).trim()
              try {
                var mainComps = JSON.parse(jsonStr)
                var mainNonSelf = (mainComps || []).filter(function (c) {
                  return !c.isSelf
                })
                return mainNonSelf.length >= 2 ? mainNonSelf : nonSelf
              } catch (e) {
                return nonSelf
              }
            })
            .catch(function () {
              return nonSelf
            })
        })
        .then(function (nonSelf) {
          if (!nonSelf || nonSelf.length < 2) {
            return
          }

          var nonSizeNonColor = nonSelf.filter(function (c) {
            if (c.hasSize) return false
            if (
              colorComponent &&
              colorComponent.handle &&
              c.handle === colorComponent.handle
            )
              return false
            if (colorComponent && colorComponent.allHandles) {
              for (var i = 0; i < colorComponent.allHandles.length; i++) {
                if (colorComponent.allHandles[i].handle === c.handle)
                  return false
              }
            }
            return true
          })

          if (nonSizeNonColor.length === 0) {
            nonSizeNonColor = nonSelf.filter(function (c) {
              return !c.hasSize
            })
            if (nonSizeNonColor.length > 1)
              nonSizeNonColor = [nonSizeNonColor[nonSizeNonColor.length - 1]]
          }

          if (nonSizeNonColor.length === 0) return

          var extraBaseComp = nonSizeNonColor[0]
          return fetchChildBundleComponentData(extraBaseComp.handle).then(
            function (sectionData) {
              var allEntries = (sectionData || []).filter(function (e) {
                return !e.isSelf
              })
              if (!allEntries.length) allEntries = sectionData || []

              applyExtraEntriesFromRecovery(
                extraValues,
                allEntries,
                extraBaseComp,
              )
            },
          )
        })
    }

    var firstHandle = candidateHandles[0].handle
    return fetchChildBundleComponentData(firstHandle).then(
      function (sectionData) {
        var allEntries = (sectionData || []).filter(function (e) {
          return !e.isSelf
        })
        if (allEntries.length > 0) {
          applyExtraEntriesFromRecovery(extraValues, allEntries, allEntries[0])
        }
      },
    )
  }

  function applyExtraEntriesFromRecovery(extraValues, allEntries, baseComp) {
    if (!extraComponent || !allEntries || !allEntries.length) return

    extraValues.forEach(function (val) {
      var slug = handleSlugify(val)
      var matched = allEntries.find(function (e) {
        if (
          e.colorLabel &&
          e.colorLabel.toLowerCase().trim() === val.toLowerCase().trim()
        )
          return true
        if (e.colorLabel && handleSlugify(e.colorLabel) === slug) return true
        if (e.handle && e.handle.indexOf(slug) >= 0) return true
        return false
      })
      if (!matched && allEntries.length === 1) matched = allEntries[0]
      if (!matched) matched = baseComp

      var title = normalizeComponentDisplayTitle(
        matched.title || (baseComp ? baseComp.title : "") || "",
        val,
      )
      if (title && !extraComponent.titles[val])
        extraComponent.titles[val] = title
      if (matched.image && !extraComponent.images[val]) {
        extraComponent.images[val] = matched.image
        if (!extraComponent.defaultImage)
          extraComponent.defaultImage = matched.image
      }
      if (
        (matched.colorLabel || matched.colorHex || matched.colorImage) &&
        !extraComponent.swatches[val]
      ) {
        extraComponent.swatches[val] = {
          hex: matched.colorHex || "",
          imageUrl: matched.colorImage || "",
          label: matched.colorLabel || val,
        }
      }
      if (matched.generation) {
        if (!extraComponent.generations)
          extraComponent.generations = Object.create(null)
        extraComponent.generations[val] = matched.generation
        extraComponent.generation = matched.generation
      }
      if (matched.handle && !handleLooksLikeBundleWrapper(matched.handle)) {
        var eExist = false
        for (var ei = 0; ei < extraComponent.allHandles.length; ei++) {
          if (extraComponent.allHandles[ei].option === val) {
            eExist = true
            break
          }
        }
        if (!eExist)
          extraComponent.allHandles.push({
            option: val,
            handle: matched.handle,
          })
      }
    })

    if (
      !extraComponent.name &&
      baseComp &&
      baseComp.title &&
      !componentNameLooksLikeWrapper(baseComp.title)
    ) {
      extraComponent.name = baseComp.title
    }
    if (
      baseComp &&
      baseComp.handle &&
      !handleLooksLikeBundleWrapper(baseComp.handle)
    ) {
      if (
        !extraComponent.handle ||
        handleLooksLikeBundleWrapper(extraComponent.handle)
      ) {
        extraComponent.handle = baseComp.handle
        extraComponent.baseHandle = baseComp.handle
      }
    }

    var popup = getActivePopup()
    if (popup && popup.getAttribute("aria-hidden") === "false") {
      applyComponentData(popup)
      applySerializedExtraSwatches(popup)
      updateComponentImages(popup)
      updateGenerationTags(popup)
    }
  }

  function applyToOpenPopup() {
    const popup = getActivePopup()
    if (!popup) return

    popup.classList.remove("is-loading")

    if (popup.getAttribute("aria-hidden") !== "false") return
    syncSelectionFromPopup(popup)
    injectFindMySizeIfNeeded(popup)
    prefetchSizeChartMarkupsForPopup(popup).catch(() => {})
    correctColorLabels(popup)
    syncDisplayedOptionValues(popup)
    applyComponentData(popup)
    applyVariantMapDerivedComponentData(popup)
    if (!isDualSizeMode) {
      applyPdpSwatches(popup)
      applySerializedColorSwatches(popup)
      applySerializedExtraSwatches(popup)
      applyVariantMapColorSwatches(popup)
    }
    updateAvailability(popup)
    // WEBD-1281: drop the loading flag BEFORE updating images so setImage
    // allows the real enrichment images through.
    clearLoadingState(popup)
    updateComponentImages(popup)
    updateExclusiveLabel(popup)
    updateExtraExclusiveLabel(popup)
  }

  function fetchComponentImagesInBackground(stateVersion) {
    var fetches = [
      sizeComponent ? fetchAllVariantImages(sizeComponent, "size") : null,
      colorComponent ? fetchAllVariantImages(colorComponent, "color") : null,
      extraComponent ? fetchAllVariantImages(extraComponent, "extra") : null,
    ].filter(Boolean)

    if (!fetches.length) return Promise.resolve()

    return Promise.all(fetches)
      .then(function () {
        if (isStaleState(stateVersion)) return
        var popup = getActivePopup()
        correctColorLabelsFromEnrichedData(popup)
        correctExtraLabelsFromEnrichedData(popup)
        if (popup && popup.getAttribute("aria-hidden") === "false") {
          applyToOpenPopup()
        }
      })
      .catch(function () {})
  }

  function addToCartWithSection(variantId) {
    return fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: CART_SECTION_ID,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        return data.sections ? data.sections[CART_SECTION_ID] : null
      })
  }

  function removeDiscoveryItem(variantId) {
    return fetch(window.routes.cart_url + ".js")
      .then((r) => r.json())
      .then((cart) => {
        const bundleItem =
          cart.items.find((item) => {
            if (!item || !item.has_components) return false
            if (!variantId) return true
            return String(item.variant_id) === String(variantId)
          }) || cart.items.find((item) => item && item.has_components)
        if (!bundleItem) return

        return fetch(window.routes.cart_change_url + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: bundleItem.key,
            quantity: 0,
          }),
        })
      })
  }

  /* ------------------------------------------------------------------ */
  /*  Component parsing                                                  */
  /* ------------------------------------------------------------------ */

  function parseComponentsFromHtml(html) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
    const compEls = doc.querySelectorAll("[data-comp-url]")

    const discovered = []
    compEls.forEach((el) => {
      const url = el.dataset.compUrl || ""
      const handle = url.split("/products/").pop().split("?")[0]
      const title = el.querySelector(".cart-item__bundle-comp-title")
      const img = el.querySelector(".cart-item__bundle-comp-img")

      if (handle) {
        discovered.push({
          handle,
          name: title
            ? title.textContent.replace(/^\d+\s*[×x]\s*/, "").trim()
            : "",
          imageUrl: img ? img.getAttribute("src") : "",
        })
      }
    })

    const sizes = [...new Set(variantMap.map((v) => v.size).filter(Boolean))]
    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]
    const firstWithSize = variantMap.find((v) => v.size)
    const firstWithColor = variantMap.find((v) => v.color)
    const defaultSize = (firstWithSize && firstWithSize.size) || sizes[0] || ""
    const defaultColor =
      (firstWithColor && firstWithColor.color) || colors[0] || ""

    if (discovered.length === 0) {
      if (sizes.length > 0 && shouldPreferSizeHintComponent(sizes, null)) {
        sizeComponent = buildHintedSingleProductComponent(
          sizeComponentHint,
          sizes,
        )
      }
      /* No component URLs in cart HTML: build color component from variant map so product images can still load (e.g. title fallback bundles) */
      if (
        colors.length > 0 &&
        variantMap.length > 0 &&
        variantMap.every((v) => v.handle)
      ) {
        const firstColorVariant = variantMap.find((v) => v.color === colors[0])
        const ch = firstColorVariant ? firstColorVariant.handle : ""
        const cs = slugify(colors[0])
        const base =
          ch && cs && ch.endsWith("-" + cs) ? ch.slice(0, -(cs.length + 1)) : ch
        colorComponent = {
          name: (firstColorVariant && firstColorVariant.title) || ch,
          handle: ch,
          baseHandle: base || ch,
          defaultImage: null,
          images: {},
          titles: {},
          swatches: {},
          swatchImages: {},
          allHandles: colors
            .map((c) => {
              const v = variantMap.find((x) => x.color === c)
              return v?.handle ? { option: c, handle: v.handle } : null
            })
            .filter(Boolean),
        }
      }
      return
    }

    discovered.forEach((comp) => {
      const slugifiedSize = defaultSize ? slugify(defaultSize) : ""
      const slugifiedColor = defaultColor ? slugify(defaultColor) : ""

      if (slugifiedSize && comp.handle.endsWith("-" + slugifiedSize)) {
        const baseHandle = comp.handle.slice(0, -(slugifiedSize.length + 1))
        sizeComponent = {
          name: comp.name,
          handle: comp.handle,
          baseHandle,
          defaultImage: comp.imageUrl,
          images: {},
          titles: {},
          swatches: {},
          swatchImages: {},
          allHandles: sizes.map((s) => ({
            option: s,
            handle: baseHandle + "-" + slugify(s),
          })),
        }
      } else if (slugifiedColor && comp.handle.endsWith("-" + slugifiedColor)) {
        const baseHandle = comp.handle.slice(0, -(slugifiedColor.length + 1))
        colorComponent = {
          name: comp.name,
          handle: comp.handle,
          baseHandle,
          defaultImage: comp.imageUrl,
          images: {},
          titles: {},
          swatches: {},
          swatchImages: {},
          allHandles: colors.map((c) => ({
            option: c,
            handle: baseHandle + "-" + slugify(c),
          })),
        }
      }
    })

    /* Assign unmatched discovered components to remaining dimensions.
       Some component products do not encode the option value in the handle,
       so suffix matching above won't catch them. Treat those as single-product
       components whose variants/swatches are resolved from the PDP. */
    const matchedHandles = new Set()
    if (sizeComponent) matchedHandles.add(sizeComponent.handle)
    if (colorComponent) matchedHandles.add(colorComponent.handle)
    const unmatchedComps = discovered.filter(
      (c) => !matchedHandles.has(c.handle),
    )

    if (!colorComponent && colors.length > 0 && unmatchedComps.length > 0) {
      const comp = unmatchedComps.shift()
      colorComponent = {
        name: comp.name,
        handle: comp.handle,
        baseHandle: comp.handle,
        defaultImage: comp.imageUrl,
        images: {},
        titles: {},
        swatches: {},
        swatchImages: {},
        allHandles: [],
        singleProduct: true,
      }
    }

    if (!sizeComponent && sizes.length > 0 && unmatchedComps.length > 0) {
      const comp = unmatchedComps.shift()
      sizeComponent = {
        name: comp.name,
        handle: comp.handle,
        baseHandle: comp.handle,
        defaultImage: comp.imageUrl,
        images: {},
        titles: {},
        swatches: {},
        swatchImages: {},
        allHandles: [],
        singleProduct: true,
      }
    }

    if (
      sizes.length > 0 &&
      shouldPreferSizeHintComponent(sizes, sizeComponent)
    ) {
      sizeComponent = buildHintedSingleProductComponent(
        sizeComponentHint,
        sizes,
      )
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Image fetching                                                     */
  /* ------------------------------------------------------------------ */

  function toAbsoluteImageUrl(url) {
    if (!url) return null
    if (/^https?:\/\//i.test(url)) return url
    return "https:" + (url.startsWith("//") ? url : "//" + url)
  }

  function getBestProductImage(product) {
    if (!product) return null
    let src = null
    if (product.featured_image) {
      src =
        typeof product.featured_image === "string"
          ? product.featured_image
          : product.featured_image.src
    }
    if (
      !src &&
      product.variants &&
      product.variants[0] &&
      product.variants[0].featured_image
    ) {
      const fe = product.variants[0].featured_image
      src = typeof fe === "string" ? fe : fe.src
    }
    if (!src && product.images && product.images.length > 0)
      src = product.images[0]
    return toAbsoluteImageUrl(src)
  }

  function fetchSingleProductImages(component, type) {
    const options =
      type === "size"
        ? [...new Set(variantMap.map((v) => v.size).filter(Boolean))]
        : [...new Set(variantMap.map((v) => v.color).filter(Boolean))]

    return fetch("/products/" + component.handle + ".json")
      .then((r) => {
        if (!r.ok) throw new Error(r.status)
        return r.json()
      })
      .then((data) => {
        const product = data.product
        if (!product) return

        if (
          !component.name &&
          product.title &&
          !componentNameLooksLikeWrapper(product.title)
        ) {
          component.name = product.title
        }
        if (!component.defaultImage && product.images && product.images[0]) {
          component.defaultImage = toAbsoluteImageUrl(product.images[0].src)
        }

        const imgById = {}
        const imgByVariantId = {}
        if (product.images) {
          product.images.forEach((img) => {
            if (img.id) imgById[img.id] = toAbsoluteImageUrl(img.src)
            if (img.variant_ids) {
              img.variant_ids.forEach((vid) => {
                imgByVariantId[vid] = toAbsoluteImageUrl(img.src)
              })
            }
          })
        }

        options.forEach((opt) => {
          if (product.title && !componentNameLooksLikeWrapper(product.title)) {
            component.titles[opt] = product.title
          }
          const slug = slugify(opt)
          const variant =
            product.variants &&
            product.variants.find((v) =>
              [v.option1, v.option2, v.option3, v.title]
                .filter(Boolean)
                .some((o) => {
                  const oSlug = slugify(o)
                  return (
                    oSlug === slug ||
                    oSlug.includes(slug) ||
                    slug.includes(oSlug)
                  )
                }),
            )

          let img = null
          if (variant) {
            img =
              imgByVariantId[variant.id] ||
              (variant.image_id && imgById[variant.image_id]) ||
              null
            if (!img && variant.featured_image) {
              const src =
                typeof variant.featured_image === "string"
                  ? variant.featured_image
                  : variant.featured_image.src
              if (src) img = toAbsoluteImageUrl(src)
            }
          }

          component.images[opt] = img || component.defaultImage
          if (type === "color" && img) {
            component.swatchImages[opt] = img
          }
        })
      })
      .then(() => {
        /* For options still using the default image, try sibling product handles
           derived from the option slug as a last resort. */
        const needsFallback = options.filter(
          (opt) =>
            !component.images[opt] ||
            component.images[opt] === component.defaultImage,
        )
        if (!needsFallback.length) return

        return Promise.all(
          needsFallback.map((opt) => {
            const guessHandle = component.handle + "-" + slugify(opt)
            return fetch("/products/" + guessHandle + ".json")
              .then((r) => {
                if (!r.ok) throw new Error(r.status)
                return r.json()
              })
              .then((data) => {
                if (
                  data.product &&
                  data.product.images &&
                  data.product.images[0]
                ) {
                  const img = toAbsoluteImageUrl(data.product.images[0].src)
                  component.images[opt] = img
                  if (
                    data.product.title &&
                    !componentNameLooksLikeWrapper(data.product.title)
                  )
                    component.titles[opt] = data.product.title
                  if (type === "color") component.swatchImages[opt] = img
                  if (
                    !component.name &&
                    data.product.title &&
                    !componentNameLooksLikeWrapper(data.product.title)
                  )
                    component.name = data.product.title
                }
              })
              .catch(() => {})
          }),
        )
      })
  }

  function fetchAllVariantImages(component, type) {
    /* For single-product components with option variants, use the .json endpoint
       which exposes image_id/variant_ids for reliable mapping. */
    if (component.singleProduct && component.handle) {
      return fetchSingleProductImages(component, type).catch(() => {})
    }

    if (!component.allHandles.length) {
      if (component.defaultImage) {
        var optionField =
          type === "size" ? "size" : type === "extra" ? "extra" : "color"
        const options = [
          ...new Set(variantMap.map((v) => v[optionField]).filter(Boolean)),
        ]
        options.forEach((opt) => {
          component.images[opt] = component.defaultImage
        })
      }
      return Promise.resolve()
    }

    const fetches = component.allHandles.map(({ option, handle }) =>
      fetch("/products/" + handle + ".js")
        .then((r) => {
          if (!r.ok) throw new Error(r.status)
          return r.json()
        })
        .then((product) => {
          const img = getBestProductImage(product)
          if (img) component.images[option] = img
          if (product.title && !componentNameLooksLikeWrapper(product.title)) {
            if (
              !component.titles[option] ||
              componentNameLooksLikeWrapper(component.titles[option])
            ) {
              component.titles[option] = product.title
            }
          }
          if (
            !component.name &&
            product.title &&
            !componentNameLooksLikeWrapper(product.title)
          ) {
            component.name = product.title
          }

          if (type === "color" && product.images && product.images[0]) {
            component.swatchImages[option] = toAbsoluteImageUrl(
              product.images[0],
            )
          }
        })
        .catch(() => {}),
    )

    return Promise.all(fetches)
  }

  function componentHasUsableHandle(component) {
    if (!component) return false
    if (component.handle && !handleLooksLikeBundleWrapper(component.handle)) {
      return true
    }
    if (component.allHandles && component.allHandles.length) {
      return component.allHandles.some(
        (entry) =>
          entry && entry.handle && !handleLooksLikeBundleWrapper(entry.handle),
      )
    }
    return false
  }

  const generationCache = {}

  function fetchGenerationFromPDP(handle) {
    if (!handle) return Promise.resolve(null)
    if (generationCache[handle] !== undefined)
      return Promise.resolve(generationCache[handle])
    return fetch("/products/" + handle)
      .then((r) => r.text())
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const genEl = doc.querySelector(".product-generation-pdp")
        const gen = genEl ? genEl.textContent.trim() : null
        generationCache[handle] = gen
        return gen
      })
      .catch(() => {
        generationCache[handle] = null
        return null
      })
  }

  function getRenderedSizeChartMarkup(popup) {
    if (!popup) return null
    const wrapper = popup.querySelector(
      "[data-bundle-size-chart-layer] .product-sizechart-wrapper",
    )
    if (!wrapper || !wrapper.dataset.sizeChartHandle) return null
    const sizeChartPopup = wrapper.querySelector(".product-sizechart-popup")
    if (!sizeChartPopup) return null
    return {
      handle: wrapper.dataset.sizeChartHandle,
      locale: wrapper.dataset.sizeChartLocale || getSizeChartLocaleKey(),
      source: "inline",
      html: sizeChartPopup.outerHTML,
    }
  }

  function getInlineSizeChartTemplateMarkup(popup, handle) {
    if (!popup || !handle) return null
    const template = popup.querySelector(
      '[data-bundle-size-chart-template="' + handle + '"]',
    )
    if (!template) return null
    const html = template.innerHTML.trim()
    if (!html) return null
    return { handle, html }
  }

  function seedInlineSizeChartMarkupCache(popup) {
    if (!popup) return

    const rendered = getRenderedSizeChartMarkup(popup)
    if (rendered && rendered.handle) {
      sizeChartMarkupCache[getSizeChartMarkupCacheKey(rendered.handle)] =
        rendered
    }

    popup
      .querySelectorAll("[data-bundle-size-chart-template]")
      .forEach((template) => {
        const handle = template.dataset.bundleSizeChartTemplate || ""
        const html = template.innerHTML.trim()
        if (!handle || !html) return
        sizeChartMarkupCache[getSizeChartMarkupCacheKey(handle)] = {
          handle,
          locale: getSizeChartLocaleKey(),
          source: "inline",
          html,
        }
      })
  }

  function hasInlineSizeChartMarkup(popup, handle) {
    if (!popup || !handle) return false
    const rendered = getRenderedSizeChartMarkup(popup)
    if (rendered && rendered.handle === handle) return true
    return !!getInlineSizeChartTemplateMarkup(popup, handle)
  }

  function getSizeChartCandidateHandles(popup, optionType) {
    seedInlineSizeChartMarkupCache(popup)

    const handles = []
    const targetType =
      optionType === "color"
        ? "color"
        : optionType === "extra"
          ? "extra"
          : "size"
    const component =
      targetType === "color"
        ? colorComponent
        : targetType === "extra"
          ? extraComponent
          : sizeComponent
    const selectedValue =
      targetType === "color"
        ? selectedColor
        : targetType === "extra"
          ? selectedExtra
          : selectedSize

    if (
      component &&
      component.sizeChartHandles &&
      component.sizeChartHandles[selectedValue]
    ) {
      handles.push(component.sizeChartHandles[selectedValue])
    }

    const sizeDetail = getVariantComponentDetail(targetType, selectedValue)

    if (
      sizeDetail &&
      sizeDetail.hasSizeChart &&
      sizeDetail.sizeChartHandle &&
      !handleLooksLikeBundleWrapper(sizeDetail.sizeChartHandle)
    ) {
      handles.push(sizeDetail.sizeChartHandle)
    }

    if (sizeDetail && sizeDetail.handle && !sizeDetail.isWrapperFallback) {
      handles.push(sizeDetail.handle)
    }

    const selectedComponentHandle = getComponentHandle(component, selectedValue)
    if (
      selectedComponentHandle &&
      !handleLooksLikeBundleWrapper(selectedComponentHandle)
    ) {
      handles.push(selectedComponentHandle)
    }

    if (
      component &&
      component.handle &&
      !handleLooksLikeBundleWrapper(component.handle)
    ) {
      handles.push(component.handle)
    }
    if (
      targetType === "size" &&
      sizeComponentHint &&
      sizeComponentHint.handle
    ) {
      if (hasInlineSizeChartMarkup(popup, sizeComponentHint.handle)) {
        handles.push(sizeComponentHint.handle)
      }
    }
    if (
      targetType === "size" &&
      popup &&
      popup.dataset.sizeComponentHintHandle
    ) {
      if (
        hasInlineSizeChartMarkup(popup, popup.dataset.sizeComponentHintHandle)
      ) {
        handles.push(popup.dataset.sizeComponentHintHandle)
      }
    }
    if (
      targetType === "color" &&
      isDualSizeMode &&
      popup &&
      popup.dataset.secondarySizeComponentHintHandle
    ) {
      if (
        hasInlineSizeChartMarkup(
          popup,
          popup.dataset.secondarySizeComponentHintHandle,
        )
      ) {
        handles.push(popup.dataset.secondarySizeComponentHintHandle)
      }
    }
    if (targetType === "extra" && popup) {
      const extraHintHandle =
        popup.dataset.extraSizeComponentHintHandle ||
        popup.dataset.secondarySizeComponentHintHandle ||
        ""
      if (extraHintHandle) {
        handles.push(extraHintHandle)
      }
    }

    return [
      ...new Set(
        handles.filter(
          (handle) => handle && !handleLooksLikeBundleWrapper(handle),
        ),
      ),
    ]
  }

  function fetchSizeChartMarkupForHandle(handle, forceFetch) {
    if (!handle) return Promise.resolve(null)
    const cacheKey = getSizeChartMarkupCacheKey(handle)
    if (cacheKey in sizeChartMarkupCache) {
      const cachedMarkup = sizeChartMarkupCache[cacheKey]
      if (!forceFetch || (cachedMarkup && cachedMarkup.source === "fetch")) {
        return Promise.resolve(cachedMarkup)
      }
    }

    return fetch(getLocalizedProductPath(handle))
      .then((r) => {
        if (!r.ok) throw new Error(r.status)
        return r.text()
      })
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const sizeChartPopup = doc.querySelector(
          ".product-sizechart-wrapper .product-sizechart-popup",
        )

        if (!sizeChartPopup) {
          sizeChartMarkupCache[cacheKey] = null
          return null
        }

        const closeBtn = sizeChartPopup.querySelector(
          ".product-sizechart-popup-close",
        )
        if (closeBtn) closeBtn.remove()

        const result = {
          handle,
          locale: getSizeChartLocaleKey(),
          source: "fetch",
          html: sizeChartPopup.outerHTML,
        }
        sizeChartMarkupCache[cacheKey] = result
        return result
      })
      .catch(() => {
        sizeChartMarkupCache[cacheKey] = null
        return null
      })
  }

  function getInlineSizeChartMarkup(popup, handles) {
    if (!popup || !handles || !handles.length) return null
    const rendered = getRenderedSizeChartMarkup(popup)
    if (rendered && handles.includes(rendered.handle)) {
      sizeChartMarkupCache[getSizeChartMarkupCacheKey(rendered.handle)] =
        rendered
      return rendered
    }

    const templates = popup.querySelectorAll(
      "[data-bundle-size-chart-template]",
    )
    for (let i = 0; i < handles.length; i++) {
      const handle = handles[i]
      for (let j = 0; j < templates.length; j++) {
        const template = templates[j]
        if (template.dataset.bundleSizeChartTemplate !== handle) continue
        const html = template.innerHTML.trim()
        if (!html) return null
        const result = {
          handle,
          locale: getSizeChartLocaleKey(),
          source: "inline",
          html,
        }
        sizeChartMarkupCache[getSizeChartMarkupCacheKey(handle)] = result
        return result
      }
    }
    return null
  }

  function prefetchSizeChartMarkupsForPopup(popup) {
    if (!popup) return Promise.resolve()
    seedInlineSizeChartMarkupCache(popup)

    const handles = []

    function pushHandle(handle) {
      if (!handle || handleLooksLikeBundleWrapper(handle)) return
      handles.push(handle)
    }

    function pushComponentHandles(component) {
      if (!component) return
      pushHandle(component.handle)
      if (component.allHandles && component.allHandles.length) {
        component.allHandles.forEach((entry) => {
          if (entry && entry.handle) pushHandle(entry.handle)
        })
      }
      if (component.sizeChartHandles) {
        Object.keys(component.sizeChartHandles).forEach((key) => {
          if (component.sizeChartHandles[key]) {
            pushHandle(component.sizeChartHandles[key])
          }
        })
      }
    }

    pushComponentHandles(sizeComponent)
    pushComponentHandles(colorComponent)

    if (sizeComponentHint && sizeComponentHint.handle) {
      pushHandle(sizeComponentHint.handle)
    }
    if (popup.dataset.sizeComponentHintHandle) {
      pushHandle(popup.dataset.sizeComponentHintHandle)
    }
    if (popup.dataset.secondarySizeComponentHintHandle) {
      pushHandle(popup.dataset.secondarySizeComponentHintHandle)
    }
    if (popup.dataset.extraSizeComponentHintHandle) {
      pushHandle(popup.dataset.extraSizeComponentHintHandle)
    }

    const uniqueHandles = [...new Set(handles)]
    if (!uniqueHandles.length) return Promise.resolve()

    return Promise.all(
      uniqueHandles.map((handle) => {
        if (getSizeChartMarkupCacheKey(handle) in sizeChartMarkupCache) {
          return Promise.resolve()
        }
        return fetchSizeChartMarkupForHandle(handle).catch(() => null)
      }),
    ).then(() => undefined)
  }

  function loadActiveSizeChart(popup, optionType) {
    const layer = popup.querySelector("[data-bundle-size-chart-layer]")
    const wrapper = layer && layer.querySelector(".product-sizechart-wrapper")
    if (!layer || !wrapper) return Promise.resolve(false)

    const handles = getSizeChartCandidateHandles(popup, optionType)
    if (!handles.length) return Promise.resolve(false)

    const localeKey = getSizeChartLocaleKey()
    if (
      wrapper.dataset.sizeChartHandle &&
      wrapper.dataset.sizeChartLocale === localeKey &&
      handles.includes(wrapper.dataset.sizeChartHandle)
    ) {
      return Promise.resolve(true)
    }

    function applySizeChartMarkup(markup) {
      if (!markup || !markup.html) return false
      wrapper.innerHTML = markup.html
      wrapper.dataset.sizeChartHandle = markup.handle
      wrapper.dataset.sizeChartLocale = markup.locale || localeKey
      return true
    }

    const fetchedMarkup = handles
      .map((handle) => sizeChartMarkupCache[getSizeChartMarkupCacheKey(handle)])
      .find((markup) => markup && markup.source === "fetch" && markup.html)

    if (fetchedMarkup) {
      applySizeChartMarkup(fetchedMarkup)
      return Promise.resolve(true)
    }

    const inlineMarkup = getInlineSizeChartMarkup(popup, handles)
    if (inlineMarkup && inlineMarkup.html) {
      applySizeChartMarkup(inlineMarkup)

      let refresh = Promise.resolve(null)
      handles.forEach((handle) => {
        refresh = refresh.then((result) => {
          if (result) return result
          return fetchSizeChartMarkupForHandle(handle, true)
        })
      })
      refresh.then((result) => {
        if (
          result &&
          result.html &&
          wrapper.dataset.sizeChartLocale === localeKey &&
          handles.includes(result.handle)
        ) {
          applySizeChartMarkup(result)
        }
      })

      return Promise.resolve(true)
    }

    let attempt = Promise.resolve(null)
    handles.forEach((handle) => {
      attempt = attempt.then((result) => {
        if (result) return result
        return fetchSizeChartMarkupForHandle(handle, true)
      })
    })

    return attempt.then((result) => {
      if (!result || !result.html) {
        return false
      }
      return applySizeChartMarkup(result)
    })
  }

  function fetchColorDataFromPDP(handle) {
    return fetch("/products/" + handle)
      .then((r) => r.text())
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const links = doc.querySelectorAll(".variant-picker-link")

        const colors = []
        links.forEach((link) => {
          const classList = link.className || ""
          const colorMatch = classList.match(/color-([^\s]+)/)
          if (!colorMatch) return
          const colorSlug = colorMatch[1]
          const href = link.getAttribute("href") || ""
          const handleMatch = href.match(/\/products\/([^/?#]+)/)

          const img = link.querySelector(".product-color-image")
          const bgSpan = link.querySelector(".variant-picker-background")
          let hex = null
          let imageUrl = null

          if (img) {
            imageUrl = img.getAttribute("src")
          }
          if (bgSpan) {
            const style = bgSpan.getAttribute("style") || ""
            const m = style.match(/background:\s*([^;]+)/)
            if (m) hex = m[1].trim()
          }

          if (hex || imageUrl) {
            colors.push({
              slug: colorSlug,
              hex,
              imageUrl,
              handle: handleMatch ? handleMatch[1] : "",
            })
          }
        })

        return colors
      })
      .catch(() => [])
  }

  function titleCase(slug) {
    if (!slug) return ""
    return slug
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ")
  }

  function mapPdpColorsToLabels(pdpColors) {
    const colorLabels = [
      ...new Set(variantMap.map((v) => v.color).filter(Boolean)),
    ]
    if (!colorLabels.length || !pdpColors.length) return {}
    const map = {}
    const unmatchedPdp = [...pdpColors]
    const unmatchedLabels = [...colorLabels]

    function stripHyphens(s) {
      return s.replace(/-/g, "")
    }

    for (const label of colorLabels) {
      const labelSlug = slugify(label)
      const labelCompact = stripHyphens(labelSlug)
      const idx = unmatchedPdp.findIndex(
        (p) =>
          p.slug === labelSlug ||
          stripHyphens(p.slug) === labelCompact ||
          p.slug.includes(labelSlug) ||
          labelSlug.includes(p.slug),
      )
      if (idx >= 0) {
        const pdpEntry = unmatchedPdp[idx]
        const corrected = titleCase(pdpEntry.slug)
        map[label] = Object.assign({}, pdpEntry, {
          correctedLabel: corrected !== label ? corrected : undefined,
        })
        unmatchedPdp.splice(idx, 1)
        const lIdx = unmatchedLabels.indexOf(label)
        if (lIdx >= 0) unmatchedLabels.splice(lIdx, 1)
      }
    }

    for (
      let i = 0;
      i < Math.min(unmatchedLabels.length, unmatchedPdp.length);
      i++
    ) {
      const pdpEntry = unmatchedPdp[i]
      const correctedLabel = titleCase(pdpEntry.slug)
      map[unmatchedLabels[i]] = Object.assign({}, pdpEntry, {
        correctedLabel: correctedLabel,
      })
    }

    return map
  }

  function getPdpColorEntry(optionValue) {
    if (!optionValue || !pdpColorData) return null
    if (pdpColorData[optionValue]) return pdpColorData[optionValue]

    const optionSlug = slugify(optionValue)
    for (const key in pdpColorData) {
      if (slugify(key) === optionSlug) return pdpColorData[key]
    }

    return null
  }

  function syncColorComponentHandlesFromPdpData() {
    if (!colorComponent || !pdpColorData) return
    if (!colorComponent.allHandles) colorComponent.allHandles = []

    Object.keys(pdpColorData).forEach((label) => {
      const entry = pdpColorData[label]
      if (!entry || !entry.handle) return
      const existing = colorComponent.allHandles.find(
        (item) =>
          item &&
          (item.option === label || slugify(item.option) === slugify(label)),
      )
      if (existing) {
        existing.handle = entry.handle
      } else {
        colorComponent.allHandles.push({
          option: label,
          handle: entry.handle,
        })
      }
    })
  }

  function getColorHandleForOption(optionValue) {
    const detail = getVariantComponentDetail("color", optionValue)
    if (detail && !detail.isWrapperFallback && detail.handle) {
      return detail.handle
    }

    const exactHandle = getExactHandleForOption(colorComponent, optionValue)
    if (exactHandle) return exactHandle

    const pdpEntry = getPdpColorEntry(optionValue)
    if (pdpEntry && pdpEntry.handle) return pdpEntry.handle

    return null
  }

  function hydrateColorComponentFromPdp(handle, stateVersion) {
    if (!handle || isDualSizeMode) return Promise.resolve()

    return fetchColorDataFromPDP(handle)
      .then((pdpColors) => {
        if (isStaleState(stateVersion) || !pdpColors || !pdpColors.length) {
          return
        }
        pdpColorData = mapPdpColorsToLabels(pdpColors)
        syncColorComponentHandlesFromPdpData()
        return retryMissingImagesWithPdpSlugs()
      })
      .then(() => {
        if (isStaleState(stateVersion)) return
        return detectExclusiveFromColorComponent()
      })
      .then(() => {
        if (isStaleState(stateVersion)) return
        const popup = getActivePopup()
        if (!popup || popup.getAttribute("aria-hidden") !== "false") return
        correctColorLabels(popup)
        applyPdpSwatches(popup)
        applySerializedColorSwatches(popup)
        applySerializedExtraSwatches(popup)
        applyVariantMapColorSwatches(popup)
        applyComponentData(popup)
        updateComponentImages(popup)
        updateExclusiveLabel(popup)
        updateExtraExclusiveLabel(popup)
      })
      .catch(() => {})
  }

  /**
   * After fetchAllVariantImages and fetchColorDataFromPDP both complete,
   * retry any color images that are still missing using the PDP color slugs
   * (which are the correct Shopify handle suffixes).
   */
  function retryMissingImagesWithPdpSlugs() {
    if (!colorComponent || !pdpColorData) return Promise.resolve()

    const colors = [...new Set(variantMap.map((v) => v.color).filter(Boolean))]
    const needsRetry = colors.filter(
      (c) =>
        !colorComponent.images[c] ||
        colorComponent.images[c] === colorComponent.defaultImage,
    )
    if (!needsRetry.length) return Promise.resolve()

    const fetches = needsRetry.map((color) => {
      const pdpEntry = getPdpColorEntry(color)
      if (!pdpEntry) return Promise.resolve()
      const pdpImage = pdpEntry.imageUrl
        ? toAbsoluteImageUrl(pdpEntry.imageUrl)
        : null
      const correctHandle =
        pdpEntry.handle ||
        (pdpEntry.slug && colorComponent.baseHandle
          ? colorComponent.baseHandle + "-" + pdpEntry.slug
          : "")
      if (pdpImage) {
        if (!colorComponent.swatchImages) colorComponent.swatchImages = {}
        colorComponent.swatchImages[color] = pdpImage
        if (correctHandle && colorComponent.allHandles) {
          const entry = colorComponent.allHandles.find(
            (h) => h.option === color || slugify(h.option) === slugify(color),
          )
          if (entry) entry.handle = correctHandle
          else
            colorComponent.allHandles.push({
              option: color,
              handle: correctHandle,
            })
        }
        return Promise.resolve()
      }
      if (!correctHandle) return Promise.resolve()
      return fetch("/products/" + correctHandle + ".js")
        .then((r) => {
          if (!r.ok) throw new Error(r.status)
          return r.json()
        })
        .then((product) => {
          const img = getBestProductImage(product)
          if (img) {
            colorComponent.images[color] = img
            const ah = colorComponent.allHandles
            if (ah) {
              const entry = ah.find(
                (h) =>
                  h.option === color || slugify(h.option) === slugify(color),
              )
              if (entry) entry.handle = correctHandle
              else ah.push({ option: color, handle: correctHandle })
            }
          }
          if (
            !colorComponent.name &&
            product.title &&
            !componentNameLooksLikeWrapper(product.title)
          )
            colorComponent.name = product.title
        })
        .catch(() => {})
    })

    return Promise.all(fetches)
  }

  function correctColorLabels(popup) {
    if (!pdpColorData) return

    const corrections = {}
    for (const label in pdpColorData) {
      var data = pdpColorData[label]
      if (data.correctedLabel && data.correctedLabel !== label) {
        if (
          colorComponent &&
          colorComponent.swatches &&
          colorComponent.swatches[label]
        ) {
          var enrichedSw = colorComponent.swatches[label]
          if (enrichedSw && enrichedSw.label) continue
        }
        corrections[label] = { newLabel: data.correctedLabel, slug: data.slug }
      }
    }

    if (!Object.keys(corrections).length) return

    variantMap.forEach((v) => {
      if (v.color && corrections[v.color])
        v.color = corrections[v.color].newLabel
    })

    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      const oldLabel = btn.dataset.optionValue
      const corr = corrections[oldLabel]
      if (!corr) return
      btn.dataset.optionValue = corr.newLabel
      btn.title = corr.newLabel
      pdpColorData[corr.newLabel] = pdpColorData[oldLabel]
      delete pdpColorData[oldLabel]
    })

    var colorGroup = popup.querySelector('[data-option-type="color"]')
    if (colorGroup) {
      var valueEl = colorGroup.querySelector("[data-option-value]")
      if (valueEl && corrections[valueEl.textContent]) {
        valueEl.textContent = corrections[valueEl.textContent].newLabel
      }
    }

    if (selectedColor && corrections[selectedColor]) {
      selectedColor = corrections[selectedColor].newLabel
    }

    if (colorComponent) {
      for (const oldLabel in corrections) {
        var corr = corrections[oldLabel]
        var correctedSwatchData = pdpColorData[corr.newLabel] || null
        if (colorComponent.images[oldLabel]) {
          colorComponent.images[corr.newLabel] = colorComponent.images[oldLabel]
          delete colorComponent.images[oldLabel]
        }
        if (colorComponent.titles && colorComponent.titles[oldLabel]) {
          colorComponent.titles[corr.newLabel] = colorComponent.titles[oldLabel]
          delete colorComponent.titles[oldLabel]
        }
        if (colorComponent.swatches && colorComponent.swatches[oldLabel]) {
          colorComponent.swatches[corr.newLabel] =
            colorComponent.swatches[oldLabel]
          delete colorComponent.swatches[oldLabel]
        }
        if (colorComponent.swatches && correctedSwatchData) {
          colorComponent.swatches[corr.newLabel] = Object.assign(
            {},
            colorComponent.swatches[corr.newLabel] || {},
            {
              hex: correctedSwatchData.hex || "",
              imageUrl: correctedSwatchData.imageUrl || "",
              label: corr.newLabel,
            },
          )
        }
        if (colorComponent.swatchImages[oldLabel]) {
          colorComponent.swatchImages[corr.newLabel] =
            colorComponent.swatchImages[oldLabel]
          delete colorComponent.swatchImages[oldLabel]
        }
        if (colorComponent.allHandles && colorComponent.allHandles.length) {
          colorComponent.allHandles.forEach(function (entry) {
            if (!entry || !entry.option) return
            if (
              entry.option === oldLabel ||
              slugify(entry.option) === slugify(oldLabel)
            ) {
              entry.option = corr.newLabel
            }
          })
        }
        if (exclusiveByColor[slugify(oldLabel)] !== undefined) {
          exclusiveByColor[slugify(corr.newLabel)] =
            exclusiveByColor[slugify(oldLabel)]
          delete exclusiveByColor[slugify(oldLabel)]
        }
      }

      var missingFetches = []
      for (const oldLabel in corrections) {
        var corr = corrections[oldLabel]
        var pdpEntry = getPdpColorEntry(corr.newLabel)
        var pdpImage =
          pdpEntry && pdpEntry.imageUrl
            ? toAbsoluteImageUrl(pdpEntry.imageUrl)
            : ""
        if (!colorComponent.swatchImages) colorComponent.swatchImages = {}
        if (pdpImage) {
          colorComponent.swatchImages[corr.newLabel] = pdpImage
        }
        if (
          !colorComponent.images[corr.newLabel] &&
          pdpEntry &&
          pdpEntry.handle
        ) {
          var correctHandle = pdpEntry.handle
          missingFetches.push(
            fetch("/products/" + correctHandle + ".js")
              .then(function (r) {
                if (!r.ok) throw new Error(r.status)
                return r.json()
              })
              .then(function (product) {
                var newLabel = corr.newLabel
                var img = getBestProductImage(product)
                if (img) colorComponent.images[newLabel] = img
                if (
                  !colorComponent.name &&
                  product.title &&
                  !componentNameLooksLikeWrapper(product.title)
                )
                  colorComponent.name = product.title
              })
              .catch(function () {}),
          )
        }
      }

      if (missingFetches.length) {
        Promise.all(missingFetches).then(function () {
          var p = getActivePopup()
          if (p) {
            applyComponentData(p)
            updateComponentImages(p)
          }
        })
      }
    }
  }

  function correctColorLabelsFromEnrichedData(popup) {
    if (!colorComponent || !colorComponent.swatches) return
    var corrections = Object.create(null)
    for (var optionVal in colorComponent.swatches) {
      var sw = colorComponent.swatches[optionVal]
      if (sw && sw.label && sw.label !== optionVal) {
        corrections[optionVal] = sw.label
      }
    }
    if (!Object.keys(corrections).length) return

    variantMap.forEach(function (v) {
      if (v.color && corrections[v.color]) v.color = corrections[v.color]
    })
    if (selectedColor && corrections[selectedColor]) {
      selectedColor = corrections[selectedColor]
    }
    if (!popup) return

    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach(function (btn) {
      var old = btn.dataset.optionValue
      if (old && corrections[old]) {
        btn.dataset.optionValue = corrections[old]
        btn.title = corrections[old]
      }
    })
    var colorGroup = popup.querySelector('[data-option-type="color"]')
    if (colorGroup) {
      var valueEl = colorGroup.querySelector("[data-option-value]")
      if (valueEl && corrections[valueEl.textContent.trim()]) {
        valueEl.textContent = corrections[valueEl.textContent.trim()]
      }
    }
    for (var oldLabel in corrections) {
      var newLabel = corrections[oldLabel]
      if (colorComponent.images[oldLabel]) {
        colorComponent.images[newLabel] = colorComponent.images[oldLabel]
        delete colorComponent.images[oldLabel]
      }
      if (colorComponent.titles && colorComponent.titles[oldLabel]) {
        colorComponent.titles[newLabel] = colorComponent.titles[oldLabel]
        delete colorComponent.titles[oldLabel]
      }
      colorComponent.swatches[newLabel] = colorComponent.swatches[oldLabel]
      delete colorComponent.swatches[oldLabel]
      if (
        colorComponent.swatchImages &&
        colorComponent.swatchImages[oldLabel]
      ) {
        colorComponent.swatchImages[newLabel] =
          colorComponent.swatchImages[oldLabel]
        delete colorComponent.swatchImages[oldLabel]
      }
      if (colorComponent.allHandles) {
        colorComponent.allHandles.forEach(function (entry) {
          if (entry && entry.option === oldLabel) entry.option = newLabel
        })
      }
      if (exclusiveByColor[slugify(oldLabel)] !== undefined) {
        exclusiveByColor[slugify(newLabel)] =
          exclusiveByColor[slugify(oldLabel)]
        delete exclusiveByColor[slugify(oldLabel)]
      }
    }
  }

  function correctExtraLabelsFromEnrichedData(popup) {
    if (!isMultiDim || !extraComponent || !extraComponent.swatches) return
    var corrections = Object.create(null)
    for (var optionVal in extraComponent.swatches) {
      var sw = extraComponent.swatches[optionVal]
      if (sw && sw.label && sw.label !== optionVal) {
        corrections[optionVal] = sw.label
      }
    }
    if (!Object.keys(corrections).length) return

    variantMap.forEach(function (v) {
      if (v.extra && corrections[v.extra]) v.extra = corrections[v.extra]
    })
    if (selectedExtra && corrections[selectedExtra]) {
      selectedExtra = corrections[selectedExtra]
    }
    if (!popup) return

    popup.querySelectorAll(EXTRA_BTN_SELECTOR).forEach(function (btn) {
      var old = btn.dataset.optionValue
      if (old && corrections[old]) {
        btn.dataset.optionValue = corrections[old]
        btn.title = corrections[old]
      }
    })
    var extraGroup = popup.querySelector('[data-option-type="extra"]')
    if (extraGroup) {
      var valueEl = extraGroup.querySelector("[data-option-value]")
      if (valueEl && corrections[valueEl.textContent.trim()]) {
        valueEl.textContent = corrections[valueEl.textContent.trim()]
      }
    }
    for (var oldLabel in corrections) {
      var newLabel = corrections[oldLabel]
      if (extraComponent.images[oldLabel]) {
        extraComponent.images[newLabel] = extraComponent.images[oldLabel]
        delete extraComponent.images[oldLabel]
      }
      if (extraComponent.titles && extraComponent.titles[oldLabel]) {
        extraComponent.titles[newLabel] = extraComponent.titles[oldLabel]
        delete extraComponent.titles[oldLabel]
      }
      extraComponent.swatches[newLabel] = extraComponent.swatches[oldLabel]
      delete extraComponent.swatches[oldLabel]
      if (
        extraComponent.swatchImages &&
        extraComponent.swatchImages[oldLabel]
      ) {
        extraComponent.swatchImages[newLabel] =
          extraComponent.swatchImages[oldLabel]
        delete extraComponent.swatchImages[oldLabel]
      }
      if (extraComponent.allHandles) {
        extraComponent.allHandles.forEach(function (entry) {
          if (entry && entry.option === oldLabel) entry.option = newLabel
        })
      }
      if (exclusiveByExtra[slugify(oldLabel)] !== undefined) {
        exclusiveByExtra[slugify(newLabel)] =
          exclusiveByExtra[slugify(oldLabel)]
        delete exclusiveByExtra[slugify(oldLabel)]
      }
    }
  }

  function applyPdpSwatches(popup) {
    if (!pdpColorData) return
    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      const label = btn.dataset.optionValue
      const data = pdpColorData[label]
      if (!data) return

      const existing = btn.querySelector(".bundle-options-popup__color-swatch")
      if (existing) existing.remove()
      const existingImg = btn.querySelector(".bundle-options-popup__color-img")
      if (existingImg) existingImg.remove()

      if (data.imageUrl) {
        const img = document.createElement("img")
        img.className = "bundle-options-popup__color-img"
        img.src = data.imageUrl
        img.alt = label
        img.width = 32
        img.height = 32
        btn.appendChild(img)
      } else if (data.hex) {
        const span = document.createElement("span")
        span.className = "bundle-options-popup__color-swatch"
        span.style.background = data.hex
        span.title = label
        btn.appendChild(span)
      }
    })
  }

  function getComponentTitle(component, selectedValue) {
    if (!component) return ""
    if (selectedValue && component.titles && component.titles[selectedValue]) {
      return component.titles[selectedValue]
    }
    if (selectedValue && component.titles) {
      const selectedSlug = slugify(selectedValue)
      for (const key in component.titles) {
        if (slugify(key) === selectedSlug) return component.titles[key]
      }
    }
    if (component.name && !componentNameLooksLikeWrapper(component.name)) {
      return component.name
    }
    return ""
  }

  function optionValuesMatch(a, b) {
    if (!a || !b) return false
    if (a === b) return true
    var sa = slugify(a),
      sb = slugify(b)
    if (sa === sb) return true
    var aWords = a.trim().split(/\s+/)
    var bWords = b.trim().split(/\s+/)
    if (aWords.length > 1 && bWords.length === 1) {
      return slugify(aWords[aWords.length - 1]) === sb
    }
    if (bWords.length > 1 && aWords.length === 1) {
      return slugify(bWords[bWords.length - 1]) === sa
    }
    return false
  }

  function normalizeColorValue(value) {
    return typeof value === "string" ? value : ""
  }

  function isWrapperVariantDetail(variant, detail) {
    if (!variant || !detail) return false
    if (detail.isSelf) return true
    if (detail.title && optionValuesMatch(detail.title, variant.title))
      return true
    if (
      detail.handle &&
      variant.handle &&
      optionValuesMatch(detail.handle, variant.handle)
    ) {
      return true
    }
    return false
  }

  function getVariantComponentDetail(type, optionValue) {
    if (!optionValue || !variantMap.length) return null

    let variant = null
    if (type === "extra") {
      variant =
        findVariant(selectedSize, selectedColor, optionValue) ||
        variantMap.find((v) => optionValuesMatch(v.extra || "", optionValue))
    } else if (type === "color") {
      variant =
        findVariant(selectedSize, optionValue, selectedExtra) ||
        variantMap.find((v) => optionValuesMatch(v.color, optionValue))
    } else {
      variant =
        findVariant(optionValue, selectedColor, selectedExtra) ||
        variantMap.find((v) => optionValuesMatch(v.size, optionValue))
    }

    if (!variant) return null

    let detail = null
    if (variant.components && variant.components.length) {
      if (isDualSizeMode) {
        const sizeLikeComponents = variant.components.filter(
          (comp) => comp && (comp.hasSize || !comp.hasColor),
        )
        const matchedBySizeValue = sizeLikeComponents.find(
          (comp) =>
            comp &&
            comp.sizeValue &&
            optionValuesMatch(comp.sizeValue, optionValue),
        )
        if (type === "color") {
          detail =
            matchedBySizeValue ||
            sizeLikeComponents[1] ||
            variant.components[1] ||
            sizeLikeComponents[0] ||
            variant.components[0]
        } else {
          detail =
            matchedBySizeValue || sizeLikeComponents[0] || variant.components[0]
        }
      } else if (type === "extra" && isMultiDim) {
        var expectedExtraHandle =
          extraComponent && getExactHandleForOption(extraComponent, optionValue)
        if (expectedExtraHandle) {
          detail =
            variant.components.find(
              (comp) =>
                comp &&
                comp.handle &&
                optionValuesMatch(comp.handle, expectedExtraHandle),
            ) || null
        }
        if (!detail) {
          var nonSizeComps = variant.components.filter((comp) => !comp.hasSize)
          detail =
            nonSizeComps[1] ||
            nonSizeComps[0] ||
            variant.components[variant.components.length - 1]
        }
      } else if (type === "color") {
        detail =
          variant.components.find(
            (comp) =>
              comp.hasColor ||
              optionValuesMatch(comp.colorLabel, optionValue) ||
              comp.colorHex ||
              comp.colorImage,
          ) ||
          variant.components.find((comp) => !comp.hasSize) ||
          variant.components[0]
      } else {
        detail =
          variant.components.find((comp) => comp.hasSize) ||
          variant.components.find((comp) => !comp.hasColor) ||
          variant.components[0]
      }
    }

    if (detail && !isWrapperVariantDetail(variant, detail)) {
      return Object.assign({}, detail, {
        colorHex: normalizeColorValue(detail.colorHex),
        isWrapperFallback: false,
      })
    }

    if (type === "size") {
      if (
        variant.sizeComponentTitle ||
        variant.sizeComponentImage ||
        variant.sizeComponentHandle
      ) {
        var sizeFallback = {
          handle: variant.sizeComponentHandle || "",
          title: variant.sizeComponentTitle || "",
          image: variant.sizeComponentImage || "",
          generation: variant.sizeComponentGeneration || "",
          hasSize: true,
        }
        return {
          handle: sizeFallback.handle,
          title: sizeFallback.title,
          image: sizeFallback.image,
          generation: sizeFallback.generation,
          hasSize: true,
          isWrapperFallback:
            (!sizeFallback.title ||
              componentNameLooksLikeWrapper(sizeFallback.title) ||
              componentImageLooksLikeWrapper(
                sizeFallback.image,
                sizeFallback.handle,
              )) &&
            (!sizeFallback.handle ||
              optionValuesMatch(sizeFallback.handle, variant.handle)),
        }
      }
    }

    if (type === "color") {
      if (
        variant.colorComponentTitle ||
        variant.colorComponentImage ||
        variant.colorSwatchHex ||
        variant.colorSwatchImage
      ) {
        var colorFallback = {
          handle: variant.colorComponentHandle || "",
          title: variant.colorComponentTitle || "",
          image: variant.colorComponentImage || "",
          generation: variant.colorComponentGeneration || "",
        }
        return {
          handle: colorFallback.handle,
          title: colorFallback.title,
          image: colorFallback.image,
          generation: colorFallback.generation,
          colorLabel: variant.colorSwatchLabel || variant.color || "",
          colorHex: normalizeColorValue(variant.colorSwatchHex),
          colorImage: variant.colorSwatchImage || "",
          hasColor: true,
          isWrapperFallback:
            (!colorFallback.title ||
              componentNameLooksLikeWrapper(colorFallback.title) ||
              componentImageLooksLikeWrapper(
                colorFallback.image,
                colorFallback.handle,
              )) &&
            (!colorFallback.handle ||
              optionValuesMatch(colorFallback.handle, variant.handle)),
        }
      }
    }

    if (!detail) return null

    return Object.assign({}, detail, {
      colorHex: normalizeColorValue(detail.colorHex),
      isWrapperFallback: isWrapperVariantDetail(variant, detail),
    })
  }

  function getEnrichedColorLabel(optionValue) {
    if (!optionValue || !colorComponent || !colorComponent.swatches)
      return optionValue
    var swatch = colorComponent.swatches[optionValue]
    if (!swatch) {
      var slug = slugify(optionValue)
      for (var k in colorComponent.swatches) {
        if (slugify(k) === slug) {
          swatch = colorComponent.swatches[k]
          break
        }
      }
    }
    if (swatch && swatch.label && swatch.label !== optionValue)
      return swatch.label
    return optionValue
  }

  function syncDisplayedOptionValues(popup) {
    if (!popup) return

    const activeSizeBtn = popup.querySelector(SIZE_BTN_SELECTOR + ".is-active")
    const sizeValue = popup.querySelector(
      '[data-option-type="size"] [data-option-value]',
    )
    if (activeSizeBtn && sizeValue) {
      sizeValue.textContent = activeSizeBtn.dataset.optionValue || ""
    }

    const activeColorBtn = popup.querySelector(
      COLOR_BTN_SELECTOR + ".is-active",
    )
    const colorValue = popup.querySelector(
      '[data-option-type="color"] [data-option-value]',
    )
    if (activeColorBtn && colorValue) {
      var rawColor = activeColorBtn.dataset.optionValue || ""
      colorValue.textContent = enrichmentDone
        ? getEnrichedColorLabel(rawColor)
        : rawColor
    }

    if (isMultiDim) {
      var activeExtraBtn = popup.querySelector(
        EXTRA_BTN_SELECTOR + ".is-active",
      )
      var extraValue = popup.querySelector(
        '[data-option-type="extra"] [data-option-value]',
      )
      if (activeExtraBtn && extraValue) {
        var rawExtra = activeExtraBtn.dataset.optionValue || ""
        extraValue.textContent = enrichmentDone
          ? getEnrichedExtraLabel(rawExtra)
          : rawExtra
      }
    }
  }

  function getEnrichedExtraLabel(optionValue) {
    if (!optionValue || !extraComponent || !extraComponent.swatches)
      return optionValue
    var swatch = extraComponent.swatches[optionValue]
    if (!swatch) {
      var slug = slugify(optionValue)
      for (var k in extraComponent.swatches) {
        if (slugify(k) === slug) {
          swatch = extraComponent.swatches[k]
          break
        }
      }
    }
    if (swatch && swatch.label && swatch.label !== optionValue)
      return swatch.label
    return optionValue
  }

  function applyVariantMapDerivedComponentData(popup) {
    if (!popup) return

    const sizeDetail = getVariantComponentDetail("size", selectedSize)
    if (sizeDetail && sizeDetail.title && !sizeDetail.isWrapperFallback) {
      setComponentNameText(popup, "size", sizeDetail.title)
    }

    const colorDetail = getVariantComponentDetail("color", selectedColor)
    if (colorDetail && colorDetail.title && !colorDetail.isWrapperFallback) {
      setComponentNameText(popup, "color", colorDetail.title)
    }
  }

  function getSelectedVariantFallback() {
    var variant = getResolvedVariant()
    if (!variant) return null

    var component =
      variant.components && variant.components.length
        ? variant.components[0]
        : null
    var componentIsWrapper = !!(
      component &&
      (component.isSelf ||
        isWrapperVariantDetail(variant, component) ||
        componentNameLooksLikeWrapper(component.title || ""))
    )
    var image =
      variant.colorComponentImage ||
      variant.sizeComponentImage ||
      (!componentIsWrapper && component && component.image) ||
      ""
    var title =
      variant.colorComponentTitle ||
      variant.sizeComponentTitle ||
      (!componentIsWrapper && component && component.title) ||
      ""
    var generation =
      variant.colorComponentGeneration ||
      variant.sizeComponentGeneration ||
      (!componentIsWrapper && component && component.generation) ||
      ""

    return {
      image: image,
      title: title,
      generation: generation,
    }
  }

  function applyImmediateVariantFallback(popup) {
    if (!popup || !currentSelectionNeedsSelfRefresh()) return

    var fallback = getSelectedVariantFallback()
    if (!fallback) return

    var targetType = selectedColor ? "color" : selectedSize ? "size" : ""
    if (!targetType) return

    if (fallback.title) {
      setComponentNameText(popup, targetType, fallback.title)
    }

    // WEBD-1281: do NOT write the image here. While the popup is in the
    // wrapper-loading state, variant.colorComponentImage etc. can resolve
    // to the bundle product's own image and would replace the shimmer
    // with the wrong picture. Wait for real enrichment to populate it.

    var genEl = popup.querySelector('[data-component-gen="' + targetType + '"]')
    if (genEl) {
      genEl.textContent = fallback.generation || ""
      genEl.classList.toggle("is-visible", !!fallback.generation)
    }
  }

  function applySerializedColorSwatches(popup) {
    if (!popup || !colorComponent || !colorComponent.swatches) return

    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      const label = btn.dataset.optionValue
      let swatch = colorComponent.swatches[label] || null

      if (!swatch) {
        const labelSlug = slugify(label)
        for (const key in colorComponent.swatches) {
          if (slugify(key) === labelSlug) {
            swatch = colorComponent.swatches[key]
            break
          }
        }
      }

      if (!swatch) return

      const existing = btn.querySelector(".bundle-options-popup__color-swatch")
      if (existing) existing.remove()
      const existingImg = btn.querySelector(".bundle-options-popup__color-img")
      if (existingImg) existingImg.remove()

      if (swatch.imageUrl) {
        const img = document.createElement("img")
        img.className = "bundle-options-popup__color-img"
        img.src = swatch.imageUrl
        img.alt = swatch.label || label
        img.width = 32
        img.height = 32
        btn.appendChild(img)
      } else if (swatch.hex) {
        const span = document.createElement("span")
        span.className = "bundle-options-popup__color-swatch"
        span.style.background = swatch.hex
        span.title = swatch.label || label
        btn.appendChild(span)
      }
    })
  }

  function applySerializedExtraSwatches(popup) {
    if (!popup || !isMultiDim || !extraComponent || !extraComponent.swatches)
      return
    popup.querySelectorAll(EXTRA_BTN_SELECTOR).forEach(function (btn) {
      var label = btn.dataset.optionValue
      var swatch = extraComponent.swatches[label] || null
      if (!swatch) {
        var labelSlug = slugify(label)
        for (var key in extraComponent.swatches) {
          if (slugify(key) === labelSlug) {
            swatch = extraComponent.swatches[key]
            break
          }
        }
      }
      if (!swatch) return
      var existing = btn.querySelector(".bundle-options-popup__color-swatch")
      if (existing) existing.remove()
      var existingImg = btn.querySelector(".bundle-options-popup__color-img")
      if (existingImg) existingImg.remove()
      if (swatch.imageUrl) {
        var img = document.createElement("img")
        img.className = "bundle-options-popup__color-img"
        img.src = swatch.imageUrl
        img.alt = swatch.label || label
        img.width = 32
        img.height = 32
        btn.appendChild(img)
      } else if (swatch.hex) {
        var span = document.createElement("span")
        span.className = "bundle-options-popup__color-swatch"
        span.style.background = swatch.hex
        span.title = swatch.label || label
        btn.appendChild(span)
      }
    })
  }

  function applyVariantMapColorSwatches(popup) {
    if (!popup) return

    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      const label = btn.dataset.optionValue
      const detail = getVariantComponentDetail("color", label)
      if (!detail || (!detail.colorHex && !detail.colorImage)) return

      const existing = btn.querySelector(".bundle-options-popup__color-swatch")
      if (existing) existing.remove()
      const existingImg = btn.querySelector(".bundle-options-popup__color-img")
      if (existingImg) existingImg.remove()

      if (detail.colorImage) {
        const img = document.createElement("img")
        img.className = "bundle-options-popup__color-img"
        img.src = detail.colorImage
        img.alt = detail.colorLabel || label
        img.width = 32
        img.height = 32
        btn.appendChild(img)
      } else if (detail.colorHex) {
        const span = document.createElement("span")
        span.className = "bundle-options-popup__color-swatch"
        span.style.background = detail.colorHex
        span.title = detail.colorLabel || label
        btn.appendChild(span)
      }
    })
  }

  function slugify(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }

  function handleSlugify(str) {
    return slugify(str.replace(/([a-z0-9])([A-Z])/g, "$1-$2"))
  }

  /* ------------------------------------------------------------------ */
  /*  Popup open / close                                                */
  /* ------------------------------------------------------------------ */

  function openPopup(popup) {
    popup.setAttribute("aria-hidden", "false")
    document.body.style.overflow = "hidden"
    document.body.classList.add("bundle-options-popup-open")

    // WEBD-1281: Always show modal immediately - don't wait for enrichment.
    // Accurate component data is preloaded in the background and applied when ready.
    popup.classList.remove("is-loading")
    applyImmediateVariantFallback(popup)
    applyToOpenPopup()

    requestAnimationFrame(() => {
      const closeBtn = popup.querySelector(".bundle-options-popup__close")
      if (closeBtn) closeBtn.focus()
    })

    if (enrichmentDone) {
      // Data already loaded, apply immediately
      syncSelectionFromPopup(popup)
      injectFindMySizeIfNeeded(popup)
      prefetchSizeChartMarkupsForPopup(popup).catch(() => {})
      correctColorLabels(popup)
      syncDisplayedOptionValues(popup)
      applyComponentData(popup)
      applyVariantMapDerivedComponentData(popup)
      if (!isDualSizeMode) {
        applyPdpSwatches(popup)
        applySerializedColorSwatches(popup)
        applySerializedExtraSwatches(popup)
        applyVariantMapColorSwatches(popup)
      }
      updateComponentImages(popup)
      updateExclusiveLabel(popup)
      updateExtraExclusiveLabel(popup)
      updateAvailability(popup)
      updateSelection(popup)
      updateGenerationTags(popup)

      var colorKey = getCurrentColorKey(popup)
      if (colorKey && exclusiveByColor[colorKey] === undefined) {
        if (isTitleFallback) {
          prefetchExclusiveDirect()
        } else {
          detectExclusiveFromColorComponent().then(function () {
            updateExclusiveLabel(popup)
          })
        }
      }
      if (isMultiDim) {
        var extraKey = getCurrentExtraKey(popup)
        if (extraKey && exclusiveByExtra[extraKey] === undefined) {
          if (isTitleFallback) {
            prefetchExclusiveDirectForExtra()
          } else {
            detectExclusiveFromExtraComponent().then(function () {
              updateExtraExclusiveLabel(popup)
            })
          }
        }
      }
    } else if (enrichmentPromise) {
      // Show modal immediately, apply data when ready
      enrichmentPromise.then(function () {
        if (popup.getAttribute("aria-hidden") !== "false") return
        popup.classList.remove("is-loading")
        applyToOpenPopup()
      })
    } else {
      // No enrichment yet, start it now but don't block modal
      discoverComponents()
    }

    if (!componentDataReady) {
      discoverComponents()
    }
  }

  function syncSelectionFromPopup(popup) {
    const activeSizeBtn = popup.querySelector(SIZE_BTN_SELECTOR + ".is-active")
    if (activeSizeBtn)
      selectedSize = activeSizeBtn.dataset.optionValue || selectedSize
    const activeColorBtn = popup.querySelector(
      COLOR_BTN_SELECTOR + ".is-active",
    )
    if (activeColorBtn)
      selectedColor = activeColorBtn.dataset.optionValue || selectedColor
    if (isMultiDim) {
      var activeExtraBtn = popup.querySelector(
        EXTRA_BTN_SELECTOR + ".is-active",
      )
      if (activeExtraBtn)
        selectedExtra = activeExtraBtn.dataset.optionValue || selectedExtra
    }
  }

  function close(popup) {
    popup.setAttribute("aria-hidden", "true")
    document.body.style.overflow = ""
    document.body.classList.remove("bundle-options-popup-open")
    if (lastTrigger) {
      lastTrigger.focus()
      lastTrigger = null
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Apply discovered component data to popup DOM                      */
  /* ------------------------------------------------------------------ */

  function applyComponentData(popup) {
    if (sizeComponent) {
      const detail = getVariantComponentDetail("size", selectedSize)
      const name =
        (isDualSizeMode &&
          detail &&
          !detail.isWrapperFallback &&
          detail.title) ||
        getComponentTitle(sizeComponent, selectedSize)
      setComponentNameText(popup, "size", name)
      applyGenTag(
        popup,
        "size",
        sizeComponent,
        selectedSize,
        isDualSizeMode &&
          detail &&
          !detail.isWrapperFallback &&
          detail.generation
          ? detail.generation
          : "",
      )
    }

    if (colorComponent) {
      const detail = getVariantComponentDetail("color", selectedColor)
      const name =
        (isDualSizeMode &&
          detail &&
          !detail.isWrapperFallback &&
          detail.title) ||
        getComponentTitle(colorComponent, selectedColor)
      setComponentNameText(popup, "color", name)
      applyGenTag(
        popup,
        "color",
        colorComponent,
        selectedColor,
        isDualSizeMode &&
          detail &&
          !detail.isWrapperFallback &&
          detail.generation
          ? detail.generation
          : "",
      )
    }

    if (isMultiDim && extraComponent) {
      var name = getComponentTitle(extraComponent, selectedExtra)
      setComponentNameText(popup, "extra", name)
      applyGenTag(popup, "extra", extraComponent, selectedExtra, "")
    }
  }

  function getComponentGeneration(component, optionValue) {
    if (!component) return ""
    if (optionValue && component.generations) {
      if (component.generations[optionValue]) {
        return component.generations[optionValue]
      }
      const optionSlug = slugify(optionValue)
      for (const key in component.generations) {
        if (slugify(key) === optionSlug && component.generations[key]) {
          return component.generations[key]
        }
      }
    }
    return component.generation || ""
  }

  function applyGenTag(
    popup,
    type,
    component,
    optionValue,
    explicitGeneration,
  ) {
    const genEl = popup.querySelector('[data-component-gen="' + type + '"]')
    if (!genEl) return
    const gen =
      explicitGeneration || getComponentGeneration(component, optionValue)
    if (gen) {
      genEl.textContent = gen
      genEl.classList.add("is-visible")
    } else {
      genEl.textContent = ""
      genEl.classList.remove("is-visible")
    }
  }

  function getExactHandleForOption(component, optionValue) {
    if (!component) return null
    if (component.singleProduct) return component.handle || null
    if (!optionValue || !component.allHandles || !component.allHandles.length) {
      return null
    }
    const entry = component.allHandles.find(
      (h) =>
        h &&
        h.handle &&
        (h.option === optionValue ||
          slugify(h.option) === slugify(optionValue)),
    )
    return entry ? entry.handle : null
  }

  function getComponentHandle(component, optionValue) {
    if (!component || !optionValue) return component ? component.handle : null
    if (component.singleProduct) return component.handle
    if (component.allHandles && component.allHandles.length) {
      const entry = component.allHandles.find(
        (h) =>
          h.option === optionValue ||
          slugify(h.option) === slugify(optionValue),
      )
      if (entry) return entry.handle
    }
    if (
      component.baseHandle &&
      !handleLooksLikeBundleWrapper(component.baseHandle)
    )
      return component.baseHandle + "-" + slugify(optionValue)
    return component.handle
  }

  function updateGenerationTags(popup) {
    function updateOne(component, type, optionValue) {
      if (!component) return
      const detail = getVariantComponentDetail(type, optionValue)
      const handle =
        (detail && !detail.isWrapperFallback && detail.handle) ||
        getExactHandleForOption(component, optionValue)
      if (!handle) return
      fetchGenerationFromPDP(handle).then((gen) => {
        if (!component.generations) component.generations = Object.create(null)
        if (optionValue) component.generations[optionValue] = gen || ""
        if (!component.generation && gen) component.generation = gen
        const isStillSelected =
          type === "size"
            ? selectedSize === optionValue
            : type === "extra"
              ? selectedExtra === optionValue
              : selectedColor === optionValue
        if (isStillSelected) {
          applyGenTag(popup, type, component, optionValue, gen || "")
        }
      })
    }
    updateOne(sizeComponent, "size", selectedSize)
    updateOne(colorComponent, "color", selectedColor)
    if (isMultiDim) updateOne(extraComponent, "extra", selectedExtra)
  }

  /* ------------------------------------------------------------------ */
  /*  Option selection                                                  */
  /* ------------------------------------------------------------------ */

  function findVariant(size, color, extra) {
    return variantMap.find((v) => {
      const sizeMatch = !size || optionValuesMatch(v.size, size)
      const colorMatch = !color || optionValuesMatch(v.color, color)
      const extraMatch =
        !isMultiDim || !extra || optionValuesMatch(v.extra || "", extra)
      return sizeMatch && colorMatch && extraMatch
    })
  }

  function getResolvedVariant() {
    return (
      findVariant(selectedSize, selectedColor, selectedExtra) ||
      findVariant("", selectedColor, selectedExtra) ||
      findVariant(selectedSize, "", selectedExtra) ||
      findVariant(selectedSize, selectedColor, "") ||
      variantMap.find((variant) => variant && variant.available) ||
      variantMap[0] ||
      null
    )
  }

  function initOptionSelectors(popup) {
    popup.querySelectorAll(SIZE_BTN_SELECTOR).forEach((btn) => {
      btn.addEventListener("click", () =>
        handleOptionSelect(popup, btn, "size"),
      )
    })
    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      btn.addEventListener("click", () =>
        handleOptionSelect(popup, btn, "color"),
      )
    })
    popup.querySelectorAll(EXTRA_BTN_SELECTOR).forEach(function (btn) {
      btn.addEventListener("click", function () {
        handleOptionSelect(popup, btn, "extra")
      })
    })
  }

  function initSizeChart(popup) {
    const layer = popup.querySelector("[data-bundle-size-chart-layer]")
    if (!layer || popup.dataset.sizeChartInitialized === "true") return
    popup.dataset.sizeChartInitialized = "true"

    const content = popup.querySelector(".bundle-options-popup__content")
    const footer = popup.querySelector(".bundle-options-popup__footer")
    const backBtn = popup.querySelector("[data-bundle-back-from-size-chart]")
    let lastSizeChartTrigger = null

    function getSizeChartPopup() {
      return layer.querySelector(".product-sizechart-popup")
    }

    function getSizeChartWrapper() {
      return layer.querySelector(".product-sizechart-wrapper")
    }

    function syncUnits() {
      const wrapper = getSizeChartWrapper()
      const toggler = wrapper && wrapper.querySelector('input[type="checkbox"]')
      if (!wrapper || !toggler) return

      const scope =
        wrapper.querySelector(".product-sizechart-popup-content") || wrapper
      const useCm = toggler.checked
      scope.querySelectorAll(".in").forEach((el) => {
        if (el.closest(".left_content_section h3")) {
          el.style.display = useCm ? "none" : "contents"
          return
        }
        el.style.display = useCm ? "none" : "inline"
      })
      scope.querySelectorAll(".cm").forEach((el) => {
        if (el.closest(".left_content_section h3")) {
          el.style.display = useCm ? "contents" : "none"
          return
        }
        el.style.display = useCm ? "inline" : "none"
      })
      scope.querySelectorAll(".size-switch .slider-label").forEach((el) => {
        el.classList.toggle(
          "active",
          el.classList.contains("slider-label-cm") === useCm,
        )
      })
    }

    function showSizeChart(triggerEl) {
      lastSizeChartTrigger = triggerEl || document.activeElement || null
      if (content) content.style.display = "none"
      if (footer) footer.style.display = "none"
      popup.classList.add("is-size-chart-open")
      layer.classList.add("is-visible")
      layer.removeAttribute("inert")
      layer.setAttribute("aria-hidden", "false")
      const sizeChartPopup = getSizeChartPopup()
      if (sizeChartPopup) sizeChartPopup.classList.add("active")
      syncUnits()
      if (backBtn) backBtn.focus()
    }

    function hideSizeChart() {
      const fallbackTrigger =
        popup.querySelector('[data-bundle-open-size-chart="size"]') ||
        popup.querySelector("[data-bundle-open-size-chart]") ||
        popup.querySelector(".bundle-options-popup__close")
      const focusTarget =
        (lastSizeChartTrigger && popup.contains(lastSizeChartTrigger)
          ? lastSizeChartTrigger
          : null) || fallbackTrigger

      if (
        document.activeElement &&
        layer.contains(document.activeElement) &&
        focusTarget &&
        typeof focusTarget.focus === "function"
      ) {
        focusTarget.focus()
      }

      popup.classList.remove("is-size-chart-open")
      layer.classList.remove("is-visible")
      layer.setAttribute("aria-hidden", "true")
      layer.setAttribute("inert", "")
      const sizeChartPopup = getSizeChartPopup()
      if (sizeChartPopup) sizeChartPopup.classList.remove("active")
      if (content) content.style.display = ""
      if (footer) footer.style.display = ""

      const wrapper = getSizeChartWrapper()
      const form = wrapper && wrapper.querySelector("form")
      if (form) form.reset()
      syncUnits()
    }

    popup.addEventListener("click", (e) => {
      const openBtn = e.target.closest("[data-bundle-open-size-chart]")
      if (!openBtn || !popup.contains(openBtn)) return
      e.preventDefault()
      e.stopPropagation()
      const optionType = openBtn.getAttribute("data-bundle-open-size-chart")
      loadActiveSizeChart(popup, optionType)
        .then((loaded) => {
          if (loaded) showSizeChart(openBtn)
        })
        .catch(() => {})
    })
    if (backBtn) backBtn.addEventListener("click", hideSizeChart)
    layer.addEventListener("click", (event) => {
      if (event.target.closest(".product-sizechart-popup-close")) {
        hideSizeChart()
      }
    })
    layer.addEventListener("change", (event) => {
      if (
        event.target.matches(
          '.product-sizechart-wrapper input[type="checkbox"]',
        )
      ) {
        syncUnits()
      }
    })
    layer.addEventListener("transitionend", () => {
      if (layer.classList.contains("is-visible")) syncUnits()
    })
    syncUnits()
  }

  function handleOptionSelect(popup, btn, type) {
    if (btn.classList.contains("is-unavailable")) return

    const optionGroup = btn.closest(".bundle-options-popup__option-group")
    var siblingSelector = SIZE_BTN_SELECTOR
    if (type === "color") siblingSelector = COLOR_BTN_SELECTOR
    else if (type === "extra") siblingSelector = EXTRA_BTN_SELECTOR
    optionGroup
      .querySelectorAll(siblingSelector)
      .forEach((s) => s.classList.remove("is-active"))
    btn.classList.add("is-active")

    const valueDisplay = optionGroup.querySelector("[data-option-value]")
    if (valueDisplay) {
      var rawVal = btn.dataset.optionValue
      valueDisplay.textContent =
        type === "color" && enrichmentDone
          ? getEnrichedColorLabel(rawVal)
          : rawVal
    }

    if (type === "size") selectedSize = btn.dataset.optionValue
    if (type === "color") selectedColor = btn.dataset.optionValue
    if (type === "extra") selectedExtra = btn.dataset.optionValue

    updateAvailability(popup)
    updateSelection(popup)
    applyComponentData(popup)
    applyVariantMapDerivedComponentData(popup)
    if (!isDualSizeMode) applyVariantMapColorSwatches(popup)
    updateGenerationTags(popup)
    if (type === "color" && !isDualSizeMode) {
      const colorKey = slugify(selectedColor)
      if (exclusiveByColor[colorKey] === undefined) {
        if (isTitleFallback) {
          prefetchExclusiveDirect().then(() => updateExclusiveLabel(popup))
        } else {
          detectExclusiveFromColorComponent().then(() =>
            updateExclusiveLabel(popup),
          )
        }
      } else {
        updateExclusiveLabel(popup)
      }
    }
    if (type === "extra" && isMultiDim) {
      const extraKey = slugify(selectedExtra)
      if (exclusiveByExtra[extraKey] === undefined) {
        if (isTitleFallback) {
          prefetchExclusiveDirectForExtra().then(() =>
            updateExtraExclusiveLabel(popup),
          )
        } else {
          detectExclusiveFromExtraComponent().then(() =>
            updateExtraExclusiveLabel(popup),
          )
        }
      } else {
        updateExtraExclusiveLabel(popup)
      }
    }
    refreshCurrentSelfVariantIfNeeded()
  }

  function updateAvailability(popup) {
    popup.querySelectorAll(SIZE_BTN_SELECTOR).forEach((btn) => {
      const testSize = btn.dataset.optionValue
      const match = variantMap.find(
        (v) =>
          optionValuesMatch(v.size, testSize) &&
          (!selectedColor || optionValuesMatch(v.color, selectedColor)) &&
          (!isMultiDim ||
            !selectedExtra ||
            optionValuesMatch(v.extra || "", selectedExtra)),
      )
      const unavailable = !match || !match.available
      btn.classList.toggle("is-unavailable", unavailable)
      btn.disabled = unavailable
    })

    popup.querySelectorAll(COLOR_BTN_SELECTOR).forEach((btn) => {
      const testColor = btn.dataset.optionValue
      const match = variantMap.find(
        (v) =>
          optionValuesMatch(v.color, testColor) &&
          (!selectedSize || optionValuesMatch(v.size, selectedSize)) &&
          (!isMultiDim ||
            !selectedExtra ||
            optionValuesMatch(v.extra || "", selectedExtra)),
      )
      const unavailable = !match || !match.available
      btn.classList.toggle("is-unavailable", unavailable)
      btn.disabled = unavailable
    })

    if (isMultiDim) {
      popup.querySelectorAll(EXTRA_BTN_SELECTOR).forEach(function (btn) {
        var testExtra = btn.dataset.optionValue
        var match = variantMap.find(function (v) {
          return (
            optionValuesMatch(v.extra || "", testExtra) &&
            (!selectedSize || optionValuesMatch(v.size, selectedSize)) &&
            (!selectedColor || optionValuesMatch(v.color, selectedColor))
          )
        })
        var unavailable = !match || !match.available
        btn.classList.toggle("is-unavailable", unavailable)
        btn.disabled = unavailable
      })
    }
  }

  function updateSelection(popup) {
    const match = findVariant(selectedSize, selectedColor, selectedExtra)
    const addBtn = popup.querySelector(ADD_BTN_SELECTOR)

    if (match) {
      if (addBtn) {
        addBtn.dataset.bundleVariantId = match.variantId
        var isSoldOut = !match.available || !!match.componentSoldOut
        addBtn.disabled = isSoldOut
        var btnLabel = addBtn.querySelector("span")
        if (btnLabel) {
          if (isSoldOut) {
            if (!addBtn.dataset.originalLabel) {
              addBtn.dataset.originalLabel = btnLabel.textContent
            }
            btnLabel.textContent =
              window.variantStrings && window.variantStrings.soldOut
                ? window.variantStrings.soldOut
                : "Sold Out"
          } else if (addBtn.dataset.originalLabel) {
            btnLabel.textContent = addBtn.dataset.originalLabel
          }
        }
      }
    } else if (addBtn) {
      addBtn.disabled = true
      var btnLabel = addBtn.querySelector("span")
      if (btnLabel && addBtn.dataset.originalLabel) {
        btnLabel.textContent = addBtn.dataset.originalLabel
      }
    }

    // WEBD-1281: Ensure selected variant enrichment is loaded immediately
    var selectedVariant = match
    var needsEnrichment =
      selectedVariant &&
      (!selectedVariant.components || !selectedVariant.components.length)

    if (needsEnrichment) {
      // Variant needs enrichment - fetch it immediately (don't defer to background)
      applyImmediateVariantFallback(popup)
      var selectedHandle = selectedVariant.handle || null

      if (selectedHandle) {
        fetchChildBundleComponentData(selectedHandle)
          .then(function (comps) {
            if (comps && comps.length && selectedVariant) {
              var hasReal = comps.some(function (c) {
                return c && !c.isSelf
              })
              selectedVariant.components = comps
              applyComponentData(popup)
              applyVariantMapDerivedComponentData(popup)
              // WEBD-1281: real enrichment data arrived for the active
              // variant - clear the popup-level shimmer flag and update
              // component images (which were blocked during loading).
              if (hasReal) {
                enrichmentDone = true
                clearLoadingState(popup)
                updateComponentImages(popup)
              }
            }
          })
          .catch(function () {
            // If fetch fails, continue with partial data
            applyComponentData(popup)
            applyVariantMapDerivedComponentData(popup)
          })
      }
    } else {
      // Data already loaded, apply immediately
      applyComponentData(popup)
      applyVariantMapDerivedComponentData(popup)
    }

    // These don't depend on enrichment
    injectFindMySizeIfNeeded(popup)
    if (!isDualSizeMode) applyVariantMapColorSwatches(popup)
    if (!isDualSizeMode) updateExclusiveLabel(popup)
    updateExtraExclusiveLabel(popup)

    // Fetch images in background without blocking content update
    requestAnimationFrame(() => {
      updateComponentImages(popup)
    })
  }

  function getComponentImageUrl(component, selectedValue) {
    if (!component || !selectedValue)
      return component ? component.defaultImage : null
    const exact = component.images[selectedValue]
    if (exact) return exact
    const selectedSlug = slugify(selectedValue)
    for (const key in component.images) {
      if (!component.images[key]) continue
      if (slugify(key) === selectedSlug) return component.images[key]
      if (key.toLowerCase() === selectedValue.toLowerCase())
        return component.images[key]
    }
    return component.defaultImage
  }

  function getHandleForOption(component, option) {
    if (!component || !option) return null
    if (component.singleProduct) return component.handle
    const entry =
      component.allHandles &&
      component.allHandles.find(
        (h) =>
          slugify(h.option) === slugify(option) ||
          h.option.toLowerCase() === option.toLowerCase(),
      )
    const pdpHandle =
      component === colorComponent ? getColorHandleForOption(option) : null
    if (entry && entry.handle) return entry.handle
    if (pdpHandle) return pdpHandle
    return component.baseHandle &&
      !handleLooksLikeBundleWrapper(component.baseHandle)
      ? component.baseHandle + "-" + slugify(option)
      : null
  }

  function fetchImageForOption(component, option, type) {
    if (component.singleProduct) {
      if (component.images[option])
        return Promise.resolve(component.images[option])
      return fetchSingleProductImages(component, type)
        .then(() => component.images[option] || component.defaultImage)
        .catch(() => null)
    }
    const handle = getHandleForOption(component, option)
    if (!handle) return Promise.resolve(null)
    return fetch("/products/" + handle + ".js")
      .then((r) => {
        if (!r.ok) throw new Error(r.status)
        return r.json()
      })
      .then((product) => {
        const img = getBestProductImage(product)
        if (img) component.images[option] = img
        return img
      })
      .catch(() => null)
  }

  function updateComponentImages(popup) {
    if (!popup) return

    function updateOneComponent(component, container, selected, type) {
      if (!component || !container) return
      const detail = getVariantComponentDetail(type, selected)
      const resolvedImage = getComponentImageUrl(component, selected)
      const detailImage =
        detail &&
        !detail.isWrapperFallback &&
        detail.image &&
        !componentImageLooksLikeWrapper(detail.image, detail.handle || "")
          ? detail.image
          : null
      const imgUrl = resolvedImage || detailImage
      if (imgUrl) {
        setImage(container, imgUrl)
      } else if (selected) {
        if (
          currentSelectionNeedsSelfRefresh() &&
          (!detail || detail.isWrapperFallback || !detail.image)
        ) {
          return
        }
        fetchImageForOption(component, selected, type).then((url) => {
          if (url) {
            component.images[selected] = url
            const p = getActivePopup()
            if (p) {
              const c = p.querySelector('[data-component-img="' + type + '"]')
              if (c) setImage(c, url)
            }
          }
        })
      }
    }

    updateOneComponent(
      sizeComponent,
      popup.querySelector('[data-component-img="size"]'),
      selectedSize,
      "size",
    )
    updateOneComponent(
      colorComponent,
      popup.querySelector('[data-component-img="color"]'),
      selectedColor,
      "color",
    )
    if (isMultiDim && extraComponent) {
      updateOneComponent(
        extraComponent,
        popup.querySelector('[data-component-img="extra"]'),
        selectedExtra,
        "extra",
      )
    }
  }

  function setImage(container, src) {
    // While the popup is still loading component data, block ALL image
    // updates — any src at this point could be a wrapper/bundle image.
    // Images are re-applied by applyToOpenPopup / clearLoadingState once
    // real enrichment data has arrived.
    var popupEl = container.closest(".bundle-options-popup")
    if (
      popupEl &&
      popupEl.classList.contains("is-loading-component-data") &&
      container.classList.contains("is-awaiting-component")
    ) {
      return
    }

    let img = container.querySelector("img")
    const placeholder = container.querySelector(
      ".bundle-options-popup__img-placeholder",
    )
    if (placeholder) placeholder.remove()

    if (!img) {
      img = document.createElement("img")
      img.className = "bundle-options-popup__img"
      img.loading = "lazy"
      img.width = 96
      container.appendChild(img)
    }

    if (img.src !== src) {
      img.src = src
    }
    if (src) {
      img.style.visibility = ""
      container.classList.remove("is-awaiting-component")
    }
  }

  function setComponentNameText(popup, type, text) {
    if (!popup || !type) return
    var el = popup.querySelector('[data-component-name="' + type + '"]')
    if (!el) return
    if (text) {
      el.textContent = text
      el.classList.remove("is-awaiting-component")
    }
  }

  function parseCartAddResponse(response) {
    const contentType = (
      response.headers.get("content-type") || ""
    ).toLowerCase()
    return response.text().then((text) => {
      try {
        return JSON.parse(text)
      } catch (parseError) {
        const err = new Error("Expected JSON response from cart add")
        err.responseText = text
        err.contentType = contentType
        err.cause = parseError
        throw err
      }
    })
  }

  function getCartAddUrl() {
    if (typeof routes !== "undefined" && routes && routes.cart_add_url) {
      return routes.cart_add_url
    }
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url
    }
    return "/cart/add"
  }

  /* ------------------------------------------------------------------ */
  /*  Add to cart                                                       */
  /* ------------------------------------------------------------------ */

  function initAddToCart(popup) {
    const addBtn = popup.querySelector(ADD_BTN_SELECTOR)
    if (!addBtn) return

    addBtn.addEventListener("click", () => {
      if (addBtn.classList.contains("loading") || addBtn.disabled) return

      addBtn.classList.add("loading")
      const spinner = addBtn.querySelector(".loading__spinner")
      if (spinner) spinner.classList.remove("hidden")

      syncSelectionFromPopup(popup)
      updateSelection(popup)

      const resolvedVariant = getResolvedVariant()
      const variantId =
        addBtn.dataset.bundleVariantId ||
        (resolvedVariant ? resolvedVariant.variantId : "")
      if (!variantId) {
        addBtn.classList.remove("loading")
        const missingSpinner = addBtn.querySelector(".loading__spinner")
        if (missingSpinner) missingSpinner.classList.add("hidden")
        return
      }

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer")

      const config =
        typeof fetchConfig === "function"
          ? fetchConfig("javascript")
          : {
              method: "POST",
              headers: {
                Accept: "application/javascript",
              },
            }
      config.headers["X-Requested-With"] = "XMLHttpRequest"
      delete config.headers["Content-Type"]

      const formData = new FormData()
      formData.append("id", variantId)
      formData.append("quantity", "1")
      formData.append("properties[_bundle_url]", window.location.pathname)
      if (selectedSize)
        formData.append("properties[_product_size]", selectedSize)
      if (selectedColor) {
        formData.append(
          isDualSizeMode
            ? "properties[_product_secondary_size]"
            : "properties[_product_color]",
          selectedColor,
        )
      }

      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id),
        )
        formData.append("sections_url", window.location.pathname)
        cart.setActiveElement(document.activeElement)
      }
      config.body = formData

      fetch(getCartAddUrl(), config)
        .then((response) => parseCartAddResponse(response))
        .then((response) => {
          if (response.status) {
            try {
              if (
                typeof publish === "function" &&
                typeof PUB_SUB_EVENTS !== "undefined" &&
                PUB_SUB_EVENTS.cartError
              ) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "bundle-options-popup",
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                })
              }
            } catch (error) {
              console.error("Bundle cart error publish failed:", error)
            }
            console.error("Bundle add to cart error:", response.description)
            return
          }

          try {
            if (
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !== "undefined"
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "bundle-options-popup",
                productVariantId: variantId,
                cartData: response,
              })
            }
          } catch (error) {
            console.error("Bundle cart update publish failed:", error)
          }

          close(popup)

          if (cart) {
            try {
              cart.renderContents(response)
            } catch (error) {
              console.error("Bundle cart drawer render failed:", error)
              window.location = window.routes.cart_url
            }
          } else {
            window.location = window.routes.cart_url
          }
        })
        .catch((e) => {
          if (e && e.responseText) {
            console.error(
              "Bundle add to cart returned non-JSON response:",
              e.contentType || "unknown",
              e.responseText.slice(0, 200),
            )
            window.location = window.routes.cart_url
            return
          }
          console.error("Bundle add to cart error:", e)
        })
        .finally(() => {
          addBtn.classList.remove("loading")
          const spinner = addBtn.querySelector(".loading__spinner")
          if (spinner) spinner.classList.add("hidden")
          if (cart && cart.classList.contains("is-empty")) {
            cart.classList.remove("is-empty")
          }
        })
    })
  }

  /* ------------------------------------------------------------------ */
  /*  Init                                                              */
  /* ------------------------------------------------------------------ */

  if (document.querySelector(POPUP_SELECTOR)) {
    init()
  } else if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
